<template>
    <main role="main" class="container">
        <div class="row">
            <div class="col-md-12 tabs">
                <div class="row">
                    <a href="/accessoriesOrdering/new" class="col-6 tab">
                        <span style="text-transform: uppercase">Интеллектуальный заказ</span>
                        <span class="count">{{ count.number }}</span>
                    </a>
                    <div class="col-6 active tab">
                        <span style="text-transform: uppercase">Ручной заказ</span>
                        <span class="count">{{ count.manual }}</span>
                    </div>
                </div>
            </div>
            <aside class="col-lg-4">
                <div class="p-4 mb-3 bg-light rounded">
                    <div class="treeview">
                        <ul class="list-group">
                            <li v-for="menuItem in menu" v-bind:key="menuItem.id" class="list-group-item" :class="{'active': (menuItem.id == lastSelectedId)}">
                                <span @click="toggleMenuItem(menuItem.id)">{{menuItem.name}}</span>
                                <span v-if="menuItem.items.length > 0" class="arrow">
                                    <i v-if="!menuItem.expanded" class="las la-angle-down"></i>
                                    <i v-else class="las la-angle-up"></i>
                                </span>
                                <ul v-if="menuItem.items" class="list-group" v-bind:class="{hidden: !menuItem.expanded}">
                                    <li v-for="menuItemChild in menuItem.items" v-bind:key="menuItemChild.id" class="list-group-item" :class="{'active': (menuItemChild.id == lastSelectedId)}">
                                        <span @click="selectMenuItemChild(menuItemChild.id, 0)">{{menuItemChild.name}}</span>
                                        <span v-if="menuItemChild.items.length > 0" class="arrow">
                                            <i v-if="!menuItemChild.expanded" class="las la-angle-down"></i>
                                            <i v-else class="las la-angle-up"></i>
                                        </span>
                                        <ul v-if="menuItemChild.items" class="list-group" v-bind:class="{hidden: !menuItemChild.expanded}">
                                            <li v-for="menuItemChild2 in menuItemChild.items" v-bind:key="menuItemChild2.id" class="list-group-item" :class="{'active': (menuItemChild2.id == lastSelectedId)}">
                                                <span @click="selectMenuItemChild(menuItemChild2.id, menuItemChild.id)">{{menuItemChild2.name}}</span>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
                <!--<button v-if="crm.user.uid == 3228 || crm.user.uid == 2543" class="btn btn-outline-primary btn-block mb-2" @click="unloadXML()">Получить ID товаров в XML формате</button>-->
                <!--<button v-if="crm.user.uid == 3228 || crm.user.uid == 2543" class="btn btn-outline-primary btn-block mb-2" @click="$modal.show('loadXML')">Загрузить заказ в XML формате</button>-->
                <!--<div v-if="crm.user.uid == 3228 || crm.user.uid == 2543" class="text-center">Как сделать заказ в XML формате <button @click="$modal.show('about-xml')" class="btn btn-outline-primary" style="vertical-align: 0px; margin-left: 5px;"><i class="las la-info"></i></button></div>-->

                <button class="btn btn-outline-primary btn-block mb-2" @click="unloadXML()">
                    <div v-if="fileLoading" class="spinner-border text-primary" role="status" style="vertical-align: -2px; width: 1rem; height: 1rem;">
                        <span class="sr-only">Loading...</span>
                    </div>
                    Получить ID товаров в XML формате
                </button>
                <button class="btn btn-outline-primary btn-block mb-2" @click="$modal.show('loadXML')">Загрузить заказ в XML формате</button>
                <div class="text-center">Как сделать заказ в XML формате <button @click="$modal.show('about-xml')" class="btn btn-outline-primary" style="vertical-align: 0px; margin-left: 5px;"><i class="las la-info"></i></button></div>
            </aside>
            <div class="col-lg-8">
                <div class="row">
                    <div class="col-md-12 catalogTable mb-5">
                        <!--<h3 class="pb-4 mb-4 border-bottom" style="line-height: 1.8;">-->
                        <!--{{header}} <a href="/configurator" v-bind:class="{'btn-primary': addedButton, 'btn-outline-primary': !addedButton}" class="btn backButton"><i class="las la-angle-left"></i> Заказ комплектующих</a>-->
                        <!--&lt;!&ndash;                            {{header}} <a href="/configurator" v-bind:class="{'btn-primary': addedButton, 'btn-outline-primary': !addedButton}" class="btn backButton"><i class="las la-angle-left"></i> Заказ комплектующих <span>{{ count }}</span></a>&ndash;&gt;-->
                        <!--</h3>-->
                        <div class="row">
                            <div class="col-md-5">
                                <input class="form-control search" v-model="search" @change="saveFilterData()" placeholder="Поиск по наименованию или ID" />
<!--                                <input class="form-control search" v-model="search" @change="saveFilterData()" placeholder="Поиск по наименованию" />-->
                            </div>
                            <div class="col-md-4">
                                <a href="#" class="filterButton" v-if="[9467, 8460, 30004973, 30004746].indexOf(lastTopID) != -1 || lastSelectedId == 8436" @click="filterOpened = !filterOpened">Фильтр <i v-if="filterOpened" class="las la-angle-up"></i><i v-else class="las la-angle-down"></i></a>
                            </div>
                        </div>
                        <div class="row filter" v-if="([9467, 8460, 30004973, 30004746].indexOf(lastTopID) != -1 || lastSelectedId == 8436)" v-bind:class="{hidden: !filterOpened}">
                            <div class="filter-checkboxes" v-if="lastTopID != 30004746" v-bind:class="{'col-lg-3': lastTopID == 9467, 'col-lg-4': ([8460, 30004973, 30004746].indexOf(lastTopID) != -1 || lastSelectedId == 8436)}">
                                <p class="filter-title">Цвет материала</p>
                                <div class="button" @click="colorsFilterOpened = !colorsFilterOpened">
                                    <div class="text" v-if="filterData.colors.length > 0">Цвет ({{filterData.colors.length}})</div>
                                    <div class="text" v-else>Выбрать цвет</div>
                                </div>
                                <div v-if="colorsFilterOpened" class="overlay" @click="colorsFilterOpened = !colorsFilterOpened"></div>
                                <div class="colorsFilter" v-bind:class="{hidden: !colorsFilterOpened}">
                                    <fieldset class="fieldset-checkbox fieldset-checkbox__square">
                                        <div v-if="filtersAvailable.colors.indexOf(1) != -1" >
                                            <input id="red1" type="checkbox" value="1" class="red" @click="toggleFilterData('colors', 1)">
                                            <label for="red1" title="Красный">Красный</label>
                                        </div>
                                        <div v-if="filtersAvailable.colors.indexOf(2) != -1">
                                            <input id="orange2" type="checkbox" value="2" class="orange" @click="toggleFilterData('colors', 2)">
                                            <label for="orange2" title="Оранжевый">Оранжевый</label>
                                        </div>
                                        <div v-if="filtersAvailable.colors.indexOf(3) != -1">
                                            <input id="yellow3" type="checkbox" value="3" class="yellow" @click="toggleFilterData('colors', 3)">
                                            <label for="yellow3" title="Желтый">Желтый</label>
                                        </div>
                                        <div v-if="filtersAvailable.colors.indexOf(4) != -1">
                                            <input id="green4" type="checkbox" value="4" class="green" @click="toggleFilterData('colors', 4)">
                                            <label for="green4" title="Зеленый">Зеленый</label>
                                        </div>
                                        <div v-if="filtersAvailable.colors.indexOf(5) != -1">
                                            <input id="blue5" type="checkbox" value="5" class="blue" @click="toggleFilterData('colors', 5)">
                                            <label for="blue5" title="Синий">Синий</label>
                                        </div>
                                        <div v-if="filtersAvailable.colors.indexOf(6) != -1">
                                            <input id="purple6" type="checkbox" value="6" class="purple" @click="toggleFilterData('colors', 6)">
                                            <label for="purple6" title="Розовый">Розовый</label>
                                        </div>
                                        <div v-if="filtersAvailable.colors.indexOf(7) != -1">
                                            <input id="black7" type="checkbox" value="7" class="black" @click="toggleFilterData('colors', 7)">
                                            <label for="black7" title="Черный">Черный</label>
                                        </div>
                                        <div v-if="filtersAvailable.colors.indexOf(8) != -1">
                                            <input id="white8" type="checkbox" value="8" class="white" @click="toggleFilterData('colors', 8)">
                                            <label for="white8" title="Белый">Белый</label>
                                        </div>
                                        <div v-if="filtersAvailable.colors.indexOf(9) != -1">
                                            <input id="beige9" type="checkbox" value="9" class="beige" @click="toggleFilterData('colors', 9)">
                                            <label for="beige9" title="Бежевый">Бежевый</label>
                                        </div>
                                        <div v-if="filtersAvailable.colors.indexOf(10) != -1">
                                            <input id="gray10" type="checkbox" value="10" class="gray" @click="toggleFilterData('colors', 10)">
                                            <label for="gray10" title="Серый">Серый</label>
                                        </div>
                                        <div v-if="filtersAvailable.colors.indexOf(11) != -1">
                                            <input id="brown11" type="checkbox" value="11" class="brown" @click="toggleFilterData('colors', 11)">
                                            <label for="brown11" title="Коричневый">Коричневый</label>
                                        </div>
                                    </fieldset>
                                </div>
                            </div>
                            <div class="col-lg-3 filter-checkboxes light" v-if="lastTopID == 9467">
                                <p class="filter-title">Тип</p>
                                <fieldset class="fieldset-checkbox fieldset-checkbox__square">
                                    <div v-if="filtersAvailable.types.indexOf(1) != -1">
                                        <input id="rolo" type="checkbox" value="0" class="light_gray" @click="toggleFilterData('types', 1)">
                                        <label for="rolo">Ткани для рулонных штор</label>
                                    </div>
                                    <div v-if="filtersAvailable.types.indexOf(2) != -1">
                                        <input id="zebra" type="checkbox" value="1" class="light_gray" @click="toggleFilterData('types', 2)">
                                        <label for="zebra">Ткани для рулонных штор DUO (зебра)</label>
                                    </div>
                                </fieldset>
                            </div>
                            <div class="filter-checkboxes light" v-if="lastSelectedId != 8436 && lastTopID != 30004746" v-bind:class="{'col-lg-3': lastTopID == 9467, 'col-lg-4': [8460, 30004973, 30004746].indexOf(lastTopID) != -1}">
                                <p class="filter-title">Светопроницаемость</p>
                                <fieldset class="fieldset-checkbox fieldset-checkbox__square">
                                    <div v-if="filtersAvailable.blackouts.indexOf(0) != -1 && (filterData.types.length == 2 || filterData.types.indexOf(2) == -1)">
                                        <input id="blackout0" type="checkbox" value="0" class="light_gray" @click="toggleFilterData('blackouts', 0)">
                                        <label for="blackout0">70%</label>
                                    </div>
                                    <!--                                    <div>-->
                                    <!--                                        <input id="blackout1" type="checkbox" value="1" class="beige" @click="toggleFilterData('blackouts', 1)">-->
                                    <!--                                        <label for="blackout1">70%</label>-->
                                    <!--                                    </div>-->
<!--                                    <div v-if="filtersAvailable.blackouts.indexOf(2) != -1  && (filterData.types.length == 2 || filterData.types.indexOf(2) == -1)">-->
<!--                                        <input id="blackout2" type="checkbox" value="2" class="light_gray" @click="toggleFilterData('blackouts', 2)">-->
<!--                                        <label for="blackout2">50%</label>-->
<!--                                    </div>-->
                                    <div v-if="filtersAvailable.blackouts.indexOf(3) != -1  && (filterData.types.length == 2 || filterData.types.indexOf(2) == -1)">
                                        <input id="blackout3" type="checkbox" value="3" class="light_gray" @click="toggleFilterData('blackouts', 3)">
                                        <label for="blackout3">50%</label>
                                    </div>
                                    <div v-if="filtersAvailable.blackouts.indexOf(4) != -1  && (filterData.types.length == 2 || filterData.types.indexOf(2) == -1)">
                                        <input id="blackout4" type="checkbox" value="4" class="light_gray" @click="toggleFilterData('blackouts', 4)">
                                        <label for="blackout4">20%</label>
                                    </div>
                                    <div v-if="filtersAvailable.blackouts.indexOf(5) != -1">
                                        <input id="blackout5" type="checkbox" value="5" class="light_gray" @click="toggleFilterData('blackouts', 5)">
                                        <label for="blackout5">Blackout</label>
                                    </div>
                                </fieldset>
                            </div>
                            <div class="filter-checkboxes price" v-bind:class="{'col-lg-3': lastTopID == 9467, 'col-lg-4': ([8460, 30004973, 30004746].indexOf(lastTopID) != -1 || lastSelectedId == 8436)}">
                                <p class="filter-title">Ценовая категория</p>
                                <fieldset class="fieldset-checkbox fieldset-checkbox__square">
                                    <div v-if="filtersAvailable.prices.indexOf(0) != -1">
                                        <input id="price0" type="checkbox" value="0" class="light_gray" @click="toggleFilterData('prices', 0)">
                                        <label for="price0">0</label>
                                    </div>
                                    <div v-if="filtersAvailable.prices.indexOf(1) != -1">
                                        <input id="price1" type="checkbox" value="1" class="light_gray" @click="toggleFilterData('prices', 1)">
                                        <label for="price1">1</label>
                                    </div>
                                    <div v-if="filtersAvailable.prices.indexOf(2) != -1">
                                        <input id="price2" type="checkbox" value="2" class="light_gray" @click="toggleFilterData('prices', 2)">
                                        <label for="price2">2</label>
                                    </div>
                                    <div v-if="filtersAvailable.prices.indexOf(3) != -1">
                                        <input id="price3" type="checkbox" value="3" class="light_gray" @click="toggleFilterData('prices', 3)">
                                        <label for="price3">3</label>
                                    </div>
                                    <div v-if="filtersAvailable.prices.indexOf(4) != -1">
                                        <input id="price4" type="checkbox" value="4" class="light_gray" @click="toggleFilterData('prices', 4)">
                                        <label for="price4">4</label>
                                    </div>
                                    <div v-if="filtersAvailable.prices.indexOf(5) != -1">
                                        <input id="price5" type="checkbox" value="5" class="light_gray" @click="toggleFilterData('prices', 5)">
                                        <label for="price5">5</label>
                                    </div>
                                    <div v-if="filtersAvailable.prices.indexOf(6) != -1">
                                        <input id="price6" type="checkbox" value="6" class="light_gray" @click="toggleFilterData('prices', 6)">
                                        <label for="price6">6</label>
                                    </div>
                                    <div v-if="filtersAvailable.prices.indexOf(7) != -1">
                                        <input id="price7" type="checkbox" value="7" class="light_gray" @click="toggleFilterData('prices', 7)">
                                        <label for="price7">7</label>
                                    </div>
                                    <div v-if="filtersAvailable.prices.indexOf(8) != -1">
                                        <input id="price8" type="checkbox" value="8" class="light_gray" @click="toggleFilterData('prices', 8)">
                                        <label for="price8">8</label>
                                    </div>
                                </fieldset>
                                <p>Найдено материалов: {{filteredList.length}}</p>
                            </div>
                        </div>
                        <table class="table" v-if="filteredList.length > 0">
                            <thead>
                            <tr>
                                <td>Фото</td>
                                <td>Наименование товара</td>
                                <td>ID товара</td>
                                <td>Min заказ</td>
                                <td style="min-width: 168px;" class="text-center">Кол-во</td>
                                <td v-if="lastTopID == 8460" style="background-color: #DF771C; color: #fff;"><a href="#" class="animateNew" @click="$modal.show('about-lamels')" style="color: #fff;"><i class="las la-info-circle"></i> Цена за м² в изделии на sale.foroom.ru</a></td>
                                <td style="width: 100px;">Сумма по прайсу</td>
                                <td style="width: 100px;">Сумма со скидкой</td>
                                <td>Добавить в корзину</td>
                            </tr>
                            </thead>
                            <tbody v-for="activeListItem in filteredList" v-bind:key="activeListItem.id">

                            <tr class="item" :class="{'absent': (!activeListItem.enableStock && !activeListItem.enableStock2 && !activeListItem.enableStock3)}" :bgcolor="activeListItem.stockColor">
                                <td data-label="Фото">
                                    <!--<silentbox-single :src="'https://sale.katris.ru/img/katalog/full/' + activeListItem.img + '.png'" :autoplay="true" :description="activeListItem.name">-->
                                    <!--<img :src="'https://sale.katris.ru/img/katalog/small/' + activeListItem.img + '.png'"-->
                                    <!--:alt="activeListItem.name" />-->
                                    <!--</silentbox-single>-->
                                    <silentbox-single :src="'https://sale.katris.ru/uploads/___res_w600_q60/images/saleKatrisCatalog/' + activeListItem.img + '.png'" :autoplay="true" :description="activeListItem.name">
                                        <img :src="'https://sale.katris.ru/uploads/___res_w80_q60/images/saleKatrisCatalog/' + activeListItem.img + '.png'"
                                             :alt="activeListItem.name" />
                                    </silentbox-single>
                                </td>
                                <td data-label="Наименование товара">
                                    <span v-html="activeListItem.name" v-bind:class="{'nameSpan': activeListItem.qualityFlag}">{{activeListItem.name}}</span>

                                    <!--<div v-if="activeListItem.qualityFlag" @click="setActiveThumb(activeListItem)" class="thumb" v-tooltip.right="{content: linkContent + activeListItem.qualityFlagText, trigger: 'manual', show: activeListItem.id == activeThumbID, hideOnTargetClick: true}"><i class="las la-thumbs-up"></i></div>-->

                                    <div class="thumb">
                                        <v-popover placement="right" :show="activeListItem.id == activeThumbID" v-if="activeListItem.qualityFlag">
                                            <div @click="setActiveThumb(activeListItem)">
                                                <!--                                                <i class="las la-thumbs-up tooltip-target"></i>-->
                                                <img src="./../assets/img/thumb.png" style="width: 24px;" alt="" class="tooltip-target" />
                                            </div>

                                            <template slot="popover">
                                                <i @click="closeFlag()" v-close-popover class="closeButton las la-times-circle"></i>
                                                <div v-html="linkContent + activeListItem.qualityFlagText"></div>
                                                <div v-if="activeListItem.videoLink && activeListItem.videoLink.length > 10">
                                                    <button class="btn btn-outline-primary" @click="openVideo(activeListItem.videoLink)"><i class="las la-video"></i> Видео</button>
                                                </div>
                                            </template>
                                        </v-popover>
                                    </div>
                                </td>
                                <td data-label="ID товара">
                                    {{activeListItem.id}}
                                </td>
                                <td data-label="Min заказ">{{activeListItem.package}}{{activeListItem.measure}}</td>
                                <td data-label="Кол-во" v-if="(activeListItem.enableStock || activeListItem.enableStock2 || activeListItem.enableStock3) && boxAction.indexOf(activeListItem.id) == -1">
                                    <div class="input-group">
                                        <span class="input-group-prepend">
                                            <button type="button" class="btn quantity-left-minus" @click="itemMinus(activeListItem.id, 0)">
                                                <i class="la la-minus"></i>
                                            </button>
                                        </span>
                                        <!--                                        <input type="text" name="quantity" readonly="" class="form-control input-number" :value="activeListItem.count">-->
                                        <input type="number" name="quantity" class="form-control input-number" v-model="activeListItem.count" @input="updateCount(activeListItem.id, 0, false)" @change="updateCount(activeListItem.id, 0, true)">
                                        <span class="input-group-prepend">
                                            <button class="btn quantity-right-plus" @click="itemPlus(activeListItem.id, 0)" v-tooltip.top="{content: 'Такого количества нет на складе!', trigger: 'manual', show: activeListItem.clicked && (activeListItem.count + activeListItem.package) > activeListItem.gdsInStock}">
                                                <i class="la la-plus"></i>
                                            </button>
                                        </span>
                                    </div>
                                </td>
                                <td data-label="Кол-во" v-else-if="(activeListItem.enableStock || activeListItem.enableStock2 || activeListItem.enableStock3) && boxAction.indexOf(activeListItem.id) != -1" class="boxAction" v-tooltip.top="{content: 'Такого количества нет на складе!', trigger: 'manual', show: activeListItem.clicked && (((activeListItem.count + activeListItem.package) > activeListItem.gdsInStock) || (activeListItem.count + 800) > activeListItem.gdsInStock)}">
                                    <span v-tooltip.top="{content: 'Если нужен метраж меньше 400 м.п., закажите готовые ламели по выгодной цене, подробности уточняйте у ведущего менеджера.', trigger: 'manual', show: activeListItem.clicked2 && activeListItem.count == activeListItem.package}">Выбрано: {{activeListItem.count}}</span>
                                    <div class="countField" v-bind:class="{ notSelected: activeListItem.box }">
                                        <span>кратно min<br/>заказу</span>
                                        <div class="input-group">
                                                <span class="input-group-prepend">
                                                    <button type="button" class="btn quantity-left-minus" @click="itemMinus(activeListItem.id, 0)">
                                                        <i class="la la-minus"></i>
                                                    </button>
                                                </span>
                                            <input type="number" min="0" name="quantity" class="form-control input-number" v-model="activeListItem.count1" @input="updateCount(activeListItem.id, 0, false)" @change="updateCount(activeListItem.id, 0, true)" @click="changeInput(activeListItem, 1)">
                                            <span class="input-group-prepend">
                                                <button class="btn quantity-right-plus" @click="itemPlus(activeListItem.id, 0)" >
                                                    <i class="la la-plus"></i>
                                                </button>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="countField" v-bind:class="{ notSelected: !activeListItem.box }">
                                        <span>кратно<br/>коробке</span>
                                        <div class="boxSale">-3%</div>
                                        <div class="input-group">
                                                <span class="input-group-prepend">
                                                    <button type="button" class="btn quantity-left-minus" @click="itemMinusBox(activeListItem.id, 0)">
                                                        <i class="la la-minus"></i>
                                                    </button>
                                                </span>
                                            <input type="number" min="0" name="quantity" class="form-control input-number" v-model="activeListItem.count2" @input="updateCountBox(activeListItem.id, 0, false)" @change="updateCountBox(activeListItem.id, 0, true)" @click="changeInput(activeListItem, 2)">
                                            <span class="input-group-prepend">
                                                <button class="btn quantity-right-plus" @click="itemPlusBox(activeListItem.id, 0)" >
                                                    <i class="la la-plus"></i>
                                                </button>
                                            </span>
                                        </div>
                                    </div>
                                </td>
                                <td v-else-if="activeListItem.prihod == ''">
                                    {{activeListItem.stockAlt}}
                                </td>
                                <td v-else>
                                    {{activeListItem.prihod}}
                                </td>
                                <td v-if="lastTopID == 8460" style="background-color: #DF771C; color: #fff;" data-label="Цена за м² в изделии на sale.foroom.ru">
<!--                                    <span v-if="squareMetersPrices[activeListItem.id]" style="font-weight: 600">{{squareMetersPrices[activeListItem.id].cost}} руб. <br/><span style="font-size:9px;">* без скидки. уточните цену у мененджера</span></span>-->
                                    <span v-if="squareMetersPrices[activeListItem.id]" style="font-weight: 600">{{squareMetersPrices[activeListItem.id].cost * 0.65 | fixed }} руб.</span>
                                    <span v-else></span>
                                </td>
                                <td v-if="(activeListItem.enableStock || activeListItem.enableStock2 || activeListItem.enableStock3)" data-label="Сумма по прайсу" class="sum">
                                    <div>
                                        <span class="allSum">{{activeListItem.sum | fixed}} руб.</span>
                                        <span class="pricePerOne">{{activeListItem.priceRub | fixed}} руб./{{activeListItem.measure}}</span>
                                    </div>
                                </td>
                                <td v-else class="empty noAfter" colspan="2">
                                    <button v-if="!activeListItem.notify" class="btn btn-outline-primary" style="float: right" @click="notifyMe(activeListItem)"><i class="las la-bell"></i> Уведомить</button>
                                    <button v-if="activeListItem.notify" class="btn btn-outline-primary" style="float: right; font-size: 10px; height: 33px;" @click="disableNotifications(activeListItem)"><i class="las la-bell-slash"></i> Не уведомлять</button>
                                </td>
                                <td data-label="Сумма со скидкой" class="saleSum" v-if="(activeListItem.enableStock || activeListItem.enableStock2 || activeListItem.enableStock3)">
<!--                                    <div class="totalSale" v-if="action4.indexOf(activeListItem.id) == -1">-->
<!--                                        -<span v-if="activeListItem.boxAction">{{activeListItem.real_sale + 3}}</span>-->
<!--                                        <span v-else>{{activeListItem.real_sale}}</span>% -->
<!--                                        <span v-if="activeListItem.boxAction" style="color: grey">({{activeListItem.real_sale}}+3)</span>-->
<!--                                    </div>-->
                                    <div class="totalSale">
                                        -<span>{{activeListItem.real_sale}}</span>%
                                    </div>
<!--                                    <div v-else class="totalSale"><br/></div>-->
                                    <div>
                                        <span class="allSaleSum"> {{activeListItem.sale_sum | fixed}} руб.</span>
                                        <span class="pricePerOne"> {{activeListItem.priceRubSale | fixed}} руб./{{activeListItem.measure}}</span>
                                    </div>
                                </td>
                                <!--<td v-else class="empty"></td>-->
                                <td v-if="(activeListItem.enableStock || activeListItem.enableStock2 || activeListItem.enableStock3)">
                                    <button v-if="!activeListItem.selected" :class="{'btn-secondary': activeListItem.selected, 'btn-primary': !activeListItem.selected}" class="btn" type="button" @click="select(activeListItem.id, 0)" style="width: 108px;">
                                        <i class="las la-shopping-basket"></i> Добавить в корзину
                                    </button>
                                    <button v-if="activeListItem.selected" :class="{'btn-secondary': activeListItem.selected, 'btn-primary': !activeListItem.selected}" class="btn" type="button" @click="remove(activeListItem.id, 0)" style="width: 108px;">
                                        <i class="las la-shopping-basket"></i> Отменить
                                    </button>
                                    <!--<img v-if="activeListItem.discount_pics_ids.indexOf(activeListItem.id) !== -1" class="mt-1" src="./../assets/img/actionGet.png" />-->
                                    <img v-if="activeListItem.discount_pics_ids.indexOf(activeListItem.id) !== -1 && action2.indexOf(activeListItem.id) != -1" class="mt-1" src="./../assets/img/actionGet3.png" />
                                    <img v-else-if="activeListItem.discount_pics_ids.indexOf(activeListItem.id) !== -1 && action3.indexOf(activeListItem.id) != -1" class="mt-1" src="./../assets/img/actionGet2.png" />
                                    <img v-else-if="activeListItem.discount_pics_ids.indexOf(activeListItem.id) !== -1" class="mt-1" src="./../assets/img/actionGet.png" />
                                </td>
                                <td v-else-if="activeListItem.has_priv">
                                    <!--<button v-if="activeListItem.privileges.length > 0" class="btn btn-secondary btn-privilege" v-bind:class="{active: activeListItem.privilegesExpanded}" @click="expandPrivileges(activeListItem.id)"><i class="las la-crown"></i> Привилегия</button>-->
                                    <button class="btn btn-secondary btn-privilege" v-bind:class="{active: activeListItem.privilegesExpanded}" @click="expandPrivileges(activeListItem.id)"><i class="las la-crown"></i> Привилегия</button>
                                </td>
                                <!--<td v-else-if="[8436, 8460, 9467].indexOf(lastSelectedId) != -1 && activeListItem.analogs">-->
                                <td v-else-if="activeListItem.analogs">
                                    <button v-if="!activeListItem.analogsExpanded" class="btn btn-outline-primary" style="width: 95px;" @click="expandAnalogs(activeListItem.id)"><i class="las la-angle-down"></i> Аналоги</button>
                                    <button v-else class="btn btn-outline-primary" style="width: 95px;" @click="expandAnalogs(activeListItem.id)"><i class="las la-angle-up"></i> Аналоги</button>
                                </td>
                                <td v-else></td>
                            </tr>
                            <tr v-if="activeListItem.privilegesExpanded" class="privilege">
                                <td colspan="7">
                                    <h3 style="padding: 5px;">Привилегия</h3>
                                    <table class="table itemsList" style="border: 1px solid #dee2e6; box-shadow: 2px 3px 6px 0px #b9b9b9;">
                                        <tbody v-for="privilege in activeListItem.privileges" v-bind:key="privilege.id">
                                        <tr v-if="privilege.enableStock" :class="{'absent': (!privilege.enableStock)}" class="item" >
                                            <td data-label="Фото">
                                                <!--<silentbox-single :src="'https://sale.katris.ru/img/katalog/full/' + privilege.img +'.png'" :autoplay="true" :description="privilege.name">-->
                                                <!--<img :src="'https://sale.katris.ru/img/katalog/small/' + privilege.img + '.png'"-->
                                                <!--:alt="privilege.name" />-->
                                                <!--</silentbox-single>-->
                                                <silentbox-single :src="'https://sale.katris.ru/uploads/___res_w600_q60/images/saleKatrisCatalog/' + privilege.img + '.png'" :autoplay="true" :description="privilege.name">
                                                    <img :src="'https://sale.katris.ru/uploads/___res_w80_q60/images/saleKatrisCatalog/' + privilege.img + '.png'"
                                                         :alt="privilege.name" />
                                                </silentbox-single>
                                            </td>
                                            <td data-label="Наименование товара">{{privilege.name}}</td>
                                            <td data-label="Min заказ">{{privilege.package}}{{privilege.measure}}</td>
                                            <td data-label="Кол-во">
                                                <div v-if="privilege.enableStock" class="input-group">
                                                    <span class="input-group-prepend">
                                                        <button class="btn quantity-left-minus" @click="itemMinus(activeListItem.id, privilege.id)">
                                                            <i class="la la-minus"></i>
                                                        </button>
                                                    </span>
                                                    <input type="number" name="quantity" class="form-control input-number" min="0" v-model="privilege.count" @input="updateCount(activeListItem.id, privilege.id, false)" @change="updateCount(activeListItem.id, privilege.id, true)">
                                                    <!--                                                    <input type="text" name="quantity" readonly="" class="form-control input-number" :value="privilege.count">-->
                                                    <span class="input-group-prepend">
                                                        <button class="btn quantity-right-plus" @click="itemPlus(activeListItem.id, privilege.id)" v-tooltip.top="{content: 'Такого количества нет на складе!', trigger: 'manual', show: privilege.clicked && (privilege.count + privilege.package) > privilege.gdsInStock}">
                                                            <i class="la la-plus"></i>
                                                        </button>
                                                    </span>
                                                </div>
                                            </td>
                                            <td data-label="Сумма по прайсу" class="sum">
                                                <div v-if="privilege.enableStock">
                                                    <span class="allSum">{{privilege.sum | fixed}} руб.</span>
                                                    <span class="pricePerOne">{{privilege.priceRub | fixed}} руб./{{privilege.measure}}</span>
                                                </div>
                                            </td>
                                            <td data-label="Сумма со скидкой" class="saleSum">
                                                <div class="totalSale" v-if="privilege.enableStock">
                                                    -<span>{{privilege.priv_sale}}</span>%
                                                </div>
                                                <div v-if="privilege.enableStock">
                                                    <span class="allSaleSum"> {{privilege.sale_sum | fixed}} руб.</span>
                                                    <span class="pricePerOne"> {{privilege.priceRubSale | fixed}} руб./{{privilege.measure}}</span>
                                                </div>
                                                <!--<img v-if="privilege.discount_pics_ids.indexOf(privilege.id) !== -1" class="mt-1" src="./../assets/img/actionGet.png" />-->
                                                <img v-if="privilege.discount_pics_ids.indexOf(privilege.id) !== -1 && action2.indexOf(privilege.id) != -1" class="mt-1" src="./../assets/img/actionGet3.png" />
                                                <img v-else-if="privilege.discount_pics_ids.indexOf(privilege.id) !== -1 && action3.indexOf(privilege.id) != -1" class="mt-1" src="./../assets/img/actionGet2.png" />
                                                <img v-else-if="privilege.discount_pics_ids.indexOf(privilege.id) !== -1" class="mt-1" src="./../assets/img/actionGet.png" />
                                            </td>
                                            <td v-if="privilege.enableStock">
                                                <button v-if="!privilege.selected" class="btn btn-privilege" @click="select(activeListItem.id, privilege.id)" type="button"><i class="las la-crown"></i> Добавить</button>
                                                <input v-if="privilege.selected" class="btn btn-secondary" @click="remove(activeListItem.id, privilege.id)" value="Отменить" type="button" />
                                            </td>
                                            <td v-else>
                                                {{privilege.stockAlt}}
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                            <tr v-if="activeListItem.analogsExpanded">
                                <td colspan="7">
                                    <div class="buyMoreContainer">
                                        <h3>Аналоги</h3>
                                        <table class="table buyMore">
                                            <tbody v-for="analog in activeListItem.analogsArray" v-bind:key="analog.id">
                                            <tr v-if="analog.enableStock" :class="{'absent': (!analog.enableStock)}" class="item" >
                                                <td data-label="Фото">
                                                    <silentbox-single :src="'https://sale.katris.ru/uploads/___res_w600_q60/images/saleKatrisCatalog/' + analog.img + '.png'" :autoplay="true" :description="analog.name">
                                                        <img :src="'https://sale.katris.ru/uploads/___res_w80_q60/images/saleKatrisCatalog/' + analog.img + '.png'"
                                                             :alt="analog.name" />
                                                    </silentbox-single>
                                                </td>
                                                <td data-label="Наименование товара">{{analog.name}}</td>
                                                <td data-label="Min заказ">{{analog.package}}{{analog.measure}}</td>
                                                <td data-label="Кол-во">
                                                    <div v-if="analog.enableStock" class="input-group">
                                                        <span class="input-group-prepend">
                                                            <button class="btn quantity-left-minus" @click="itemMinus(analog.id, 0, analog)">
                                                                <i class="la la-minus"></i>
                                                            </button>
                                                        </span>
                                                        <input type="number" name="quantity" class="form-control input-number" min="0" v-model="analog.count" @input="updateCount(analog.id, 0, false)" @change="updateCount(analog.id, 0, true, analog)">
                                                        <!--                                                    <input type="text" name="quantity" readonly="" class="form-control input-number" :value="privilege.count">-->
                                                        <span class="input-group-prepend">
                                                            <button class="btn quantity-right-plus" @click="itemPlus(analog.id, 0, analog)" v-tooltip.top="{content: 'Такого количества нет на складе!', trigger: 'manual', show: analog.clicked && (analog.count + analog.package) > analog.gdsInStock}">
                                                                <i class="la la-plus"></i>
                                                            </button>
                                                        </span>
                                                    </div>
                                                </td>
                                                <td data-label="Сумма по прайсу" class="sum">
                                                    <div v-if="analog.enableStock">
                                                        <span class="allSum">{{analog.sum | fixed}} руб.</span>
                                                        <span class="pricePerOne">{{analog.priceRub | fixed}} руб./{{analog.measure}}</span>
                                                    </div>
                                                </td>
                                                <td data-label="Сумма со скидкой" class="saleSum">
                                                    <div class="totalSale" v-if="analog.enableStock">
                                                        -<span>{{analog.real_sale}}</span>%
                                                    </div>
                                                    <div v-if="analog.enableStock">
                                                        <span class="allSaleSum"> {{analog.sale_sum | fixed}} руб.</span>
                                                        <span class="pricePerOne"> {{analog.priceRubSale | fixed}} руб./{{activeListItem.measure}}</span>
                                                    </div>
                                                    <!--<img v-if="privilege.discount_pics_ids.indexOf(privilege.id) !== -1" class="mt-1" src="./../assets/img/actionGet.png" />-->
                                                    <img v-if="analog.discount_pics_ids.indexOf(analog.id) !== -1 && action2.indexOf(analog.id) != -1" class="mt-1" src="./../assets/img/actionGet3.png" />
                                                    <img v-else-if="analog.discount_pics_ids.indexOf(analog.id) !== -1 && action3.indexOf(analog.id) != -1" class="mt-1" src="./../assets/img/actionGet2.png" />
                                                    <img v-else-if="analog.discount_pics_ids.indexOf(analog.id) !== -1" class="mt-1" src="./../assets/img/actionGet.png" />
                                                </td>
                                                <td v-if="analog.enableStock">
                                                    <button v-if="!analog.selected" class="btn btn-primary" @click="select(analog.id, 0, analog)" type="button">Добавить</button>
                                                    <input v-if="analog.selected" class="btn btn-secondary" @click="remove(analog.id, 0, analog)" value="Отменить" type="button" />
                                                </td>
                                                <td v-else>
                                                    {{analog.stockAlt}}
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <h3 v-else-if="filterData.types.length > 0 || filterData.colors.length > 0 || filterData.prices.length > 0 || filterData.blackouts.length > 0">По выбранным параметрам материалов не найдено. Рекомендуем изменить параметры.</h3>
                        <h3 v-if="activeList.length == 0">Загрузка...</h3>
                    </div>
                </div>
            </div>

            <div class="col-md-12">
                <div v-if="saleFlag" class="totalEnd">
                    <h3>Общая сумма заказа:</h3>
                    <div class="row justify-content-center">
                        <div class="col-md-9">
                            <table class="table totalTable">
                                <tbody>
                                <tr>
                                    <td>Сумма заказа без скидок</td>
                                    <td>{{crm.fullsum | fixed | separate}} руб.</td>
                                </tr>
                                <tr>
                                    <td>Ваша Экономия</td>
                                    <td class="red">{{crm.fullsum - crm.saletotalsum | fixed | separate}} руб.</td>
                                </tr>
                                <tr v-for="set in manualSets" v-bind:key="set.id">
                                    <td v-if="set.calculated && set.id != 0">Комплект "{{set.hh}} {{set.hh_add}}"</td>
                                    <td v-else-if="set.id == 0">Добавлено ручным способом</td>
                                    <td class="red">{{set.sale}}%</td>
                                </tr>
                                <tr class="lastTotal">
                                    <td>Итоговая сумма заказа с персональными скидками</td>
                                    <td>{{crm.saletotalsum | fixed | separate}} руб.</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-lg-5">
                            <a href="/basket" class="btn-primary btn btn-lg btn-block mt-3"><i class="las la-shopping-basket"></i> Перейти в корзину</a>
                        </div>
                    </div>
                </div>
                <div v-else class="m-5"></div>
            </div>

            <!--<div class="col-md-12">-->
            <!--<div class="row justify-content-center">-->
            <!--<div class="col-lg-5" style="padding-bottom: 40px;">-->
            <!--<a href="/configurator/" class="btn btn-outline-primary btn-lg btn-block">-->
            <!--<i class="las la-angle-left"></i> Заказ комплектующих-->
            <!--</a>-->
            <!--</div>-->
            <!--</div>-->
            <!--</div>-->

            <nav class="navbar fixed-bottom navbar-expand-sm navbar-light bg-light saleInfo">
                <div class="container collapse navbar-collapse" id="navbarCollapse">
                    <span style="font-weight: bold;
                            border: 1px solid rgb(255, 24, 4);
                            border-radius: 25px;
                            padding: 5px 10px;
                            background-color: #fed3d3;">
                        Уважаемые партнеры, если Вы через личный кабинет<br/>
                        sale.katris не смогли выписать интересующие Вас <br/>
                        комплектующие, обратитесь к своему персональному менеджеру</span>
                    <form class="form-inline" style="margin-left: auto">
                        <button class="btn btn-outline-success my-2 my-sm-0 saleButton" type="button" @click="openPartnerProgram()">
                            <span class="big">Партнерская программа предоставления скидок</span>
                            <span class="min" style="display: none;">Партнерская программа</span>
                        </button>
                        <button class="btn btn-primary my-2 my-sm-0 saleButton" style="margin-left: 5px;" type="button" @click="openSale()"><i class="las la-shopping-cart"></i> Состояние</button>
                    </form>
                </div>
            </nav>

            <div v-if="saleVisible" class="popoverContent">
                <table class="table table-borderless" cellspacing="0">
                    <tbody>
                    <tr>
                        <td colspan="2" style="text-align: center; ">
                            <a href="javascript:" class="saleButton" @click="openSale()"><i class="las la-angle-down"></i> Свернуть</a>
                        </td>
                    </tr>

                    <tr v-if="count.basket + count.manual > 0"><td colspan="2" class="text-center" style="font-size: 17px; padding: 0"><i class="las la-shopping-cart" style="font-size: 28px;"></i> <span style="vertical-align: 3px;">Корзина</span></td></tr>
                    <tr v-if="count.basket + count.manual > 0">
                        <td>Сумма заказа без скидок</td>
                        <td>{{crm.fullsum | fixed | separate}} руб.</td>
                    </tr>
                    <tr v-if="count.basket + count.manual > 0">
                        <td>Ваша Экономия</td>
                        <td class="red">{{crm.fullsum - crm.saletotalsum | fixed | separate}} руб.</td>
                    </tr>
                    <tr v-if="count.basket + count.manual > 0">
                        <td>Итоговая сумма заказа с персональными скидками</td>
                        <td class="red">{{crm.saletotalsum | fixed | separate}} руб.</td>
                    </tr>

                    <tr v-if="count.basket + count.manual == 0"><td colspan="2" class="text-center" style="font-size: 20px;">Ваша корзина пуста</td></tr>

                    <tr style="border-top: 1px solid #8c8c8c">
                        <td>Сумма отгрузок за предыдущий период</td>
                        <td>{{crm.user.sum | fixed | separate}} руб.</td>
                    </tr>

                    <!--<tr>-->
                    <!--<td colspan="2" style="text-align: center">-->
                    <!--<a href="javascript:" @click="openPartnerProgram()"><i class="las la-info"></i> Партнерская программа предоставления скидок</a>-->
                    <!--</td>-->
                    <!--</tr>-->
                    </tbody>
                </table>
            </div>

            <modal name="partner-program" :min-width="200"
                   :min-height="200"
                   :adaptive="true"
                   :scrollable="true"
                   :reset="true"
                   width="60%"
                   height="auto">
                <div style="padding: 20px">
                    <div id="saleRules"></div>
                    <div class="row justify-content-center">
                        <div class="col-md-4">
                            <button class="btn btn-outline-primary btn-block" @click="closePartnerProgram()">Закрыть</button>
                        </div>
                    </div>
                </div>
            </modal>

            <modal name="about-xml" :min-width="200"
                   :min-height="200"
                   :adaptive="true"
                   :scrollable="true"
                   :reset="true"
                   width="60%"
                   height="auto">
                <div style="padding: 20px">
                    <div>
                        <p>Уважаемые Партнеры, вы можете загружать заказы в XML формате, для этого:</p>

                        <ul>
                            <li>Скачайте <a href="javascript:" @click="unloadXML()">список ID товаров в XML формате</a> для получения ID номеров или наименований товаров каталога КАТРИС</li>
                            <li>При формировании заказа в XML учитывайте кратность упаковки при указании необходимого количества товара и единицу измерения минимального заказа. Эта информация так же будет указана в скачанном файле.</li>
                            <li>При формировании заказа используйте правильный порядок указания информации, <a href="https://sale.katris.ru/files/xmlExample.xml" download="xmlExample.xml" target="_blank">скачайте образец</a></li>
                        </ul>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-md-4">
                            <button class="btn btn-outline-primary btn-block" @click="$modal.hide('about-xml')">Закрыть</button>
                        </div>
                    </div>
                </div>
            </modal>

            <modal name="loadXML" :min-width="200"
                   :min-height="200"
                   :adaptive="true"
                   :scrollable="true"
                   :reset="true"
                   width="60%"
                   height="auto">
                <div style="padding: 20px">
                    <div class="row">
                        <div class="col-md-12">
                            <h3>Загрузка позиций из XML файла</h3>
                        </div>
                    </div>
                    <!--<div class="row">-->
                    <!--<div class="col-md-12 text-center">-->
                    <!--<a href="javascript:" class="mb-3" style="display: block;" @click="unloadXML()">Получить список позиций каталога в XML формате</a>-->
                    <!--</div>-->
                    <!--</div>-->
                    <div class="row justify-content-center">
                        <div class="col-md-8 mb-3">
                            <input type="file" id="inputGroupFile" class="custom-file-input" @change="attachFile()" accept="application/xml" />
                            <label for="inputGroupFile" class="custom-file-label">{{fileName}}</label>
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-md-12">
                            <h3>{{loadingMessage}}</h3>
                            <p class="text-center" style="white-space: pre">{{loadingLog}}</p>
                        </div>
                    </div>
                    <div v-if="!loadingStatus" class="row justify-content-center">
                        <div class="col-md-4">
                            <button class="btn btn-outline-primary btn-block" @click="loadXMLToOrder()">Загрузить</button>
                        </div>
                        <div class="col-md-4">
                            <button class="btn btn-outline-primary btn-block" @click="$modal.hide('loadXML')">Закрыть</button>
                        </div>
                    </div>
                    <div v-if="loadingStatus" class="row justify-content-center">
                        <div class="col-md-4">
                            <a class="btn btn-outline-primary btn-block" href="/basket">Перейти в корзину</a>
                        </div>
                        <div class="col-md-4">
                            <button class="btn btn-outline-primary btn-block" @click="resetXML()">Очистить</button>
                        </div>
                    </div>
                </div>
            </modal>

            <modal name="video" :min-width="200"
                   :min-height="200"
                   :scrollable="true"
                   :reset="true"
                   width="600px"
                   height="auto">
                <div style="padding: 20px">
                    <div id="video" class="text-center">
                        <iframe width="560" height="315" :src="activeVideoLink" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-md-4">
                            <button class="btn btn-outline-primary btn-block" @click="$modal.hide('video')">Закрыть</button>
                        </div>
                    </div>
                </div>
            </modal>

            <modal name="about-lamels" :min-width="200"
                   :min-height="200"
                   :adaptive="false"
                   :scrollable="true"
                   :reset="true"
                   width="600px"
                   height="auto">
                <div style="padding: 20px">
                    <div class="row justify-content-center">
                        <div class="col-md-6">
                            <img src="../assets/img/lamels.jpg" alt="" style="width: 90%; max-width: 400px" />
                        </div>
                        <div class="col-md-6" style="font-size: 18px">
                            Цена за м2 ламелей в готовом виде на sale.foroom.ru<br/>
                            В комплект входит:<br/>
                            - Готовые ламели с прошитыми Держателями ламели 89 классик;<br/>
                            - Цепь нижняя 89 классик;<br/>
                            - Отвес ламели 89 эконом.<br/>
                            Комплект упаковывается в картонную коробку.
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-md-4">
                            <button class="btn btn-outline-primary btn-block" @click="$modal.hide('about-lamels')">Закрыть</button>
                        </div>
                    </div>
                </div>
            </modal>

            <modal name="sale" :min-width="200"
                   :min-height="200"
                   :adaptive="true"
                   :scrollable="true"
                   :reset="true"
                   width="60%"
                   height="auto">
                <div style="padding: 20px">
                    <div>
                        <p><strong>Мы пролонгировали специальное предложение до 10.04.2025.</strong></p>
<!--                        <p>Уважаемые партнеры!</p>-->
                        <p>При размещении заказа на комплектующие, увеличена система скидок <strong>на</strong><strong style="color: rgb(230, 0, 0);"> 5%</strong><strong>-ных пункта.</strong></p>
                        <p>Обратите внимание, новая система скидок отображается при заказе у вас в личном кабинете.</p>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-md-4">
                            <button class="btn btn-outline-primary btn-block" @click="$modal.hide('sale')">Закрыть</button>
                        </div>
                    </div>
                </div>
            </modal>

            <div class="notice" v-bind:class="{active: XMLAdded}">
                <p>Добавлено {{XMLCounters.added}} наименований товаров из {{XMLCounters.all}} наименований ХML - файла</p>
            </div>
        </div>
    </main>
</template>

<script>
import ai_helper from '../js/aihelper/ai_helper';
import AI_helperItemClass from '../js/aihelper/classes/ai_helperItemClass.js';
// import AI_helperComplectClass from '../js/aihelper/classes/ai_helperComplectClass.js';

let parser = require('fast-xml-parser');
let builder = require('xmlbuilder');

let series = require("async-series");

export default {
    name: "OrderFromCatalog",
    metaInfo: {
        title: 'Ручной заказ комплектующих',
        titleTemplate: '%s - sale.katris'
    },
    filters: {
        fixed(value) {
            return value.toFixed(2)
        },
        separate(value) {
            let parts = value.toString().split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            return parts.join(".");
        }
    },
    data() {
        return {
            search: '',
            menu: [],
            activeList: [],
            addList: [],
            expandedId: -1,
            lastSelectedId: 30003576,
            header: '',
            addedButton: false,
            count: {
                number: 0,
                basket: 0,
                manual: 0
            },
            saleFlag: false,
            crm: {
                user: {
                    sum: 0,
                    uid: 0
                },
                fullsum: 0,
                salesum: 0,
                saletotalsum: 0,
                fullsumPreview: 0,
                salesumPreview: 0,
                saletotalsumPreview: 0
            },
            sets: [],
            saleVisible: false,
            action2: [],
            // action3: [10096, 10097, 30005376, 30005377, 10095, 30005561, 10078, 30005621, 30005045, 30005056, 30004706, 30005189, 30004452, 30005265, 30005334, 30005325, 30005326, 30005187, 30004817],
            action3: [],
            action4: [],
            action4_back: [10484, 10510, 30003924, 30003926, 30003927, 30003931, 30003934, 30003937, 30003938, 30003989, 30003992, 30004055, 30004059, 30004141, 30004157, 30004163, 30004164, 30004170, 30004172, 30004173, 30004176, 30004179, 30004205, 30004232, 30004233, 30004235, 30004276, 30004277, 30004278, 30004469, 30004470, 30004471, 30004472, 30004473, 30004474, 30004515, 30004516, 30004517, 30004518, 30004526, 30004534, 30004563, 30004571, 30004575, 30004576],
            file: null,
            fileName: 'Выбор файла',
            loadingMessage: '',
            loadingLog: '',
            loadingStatus: false,
            loadingActive: false,
            XMLAdded: false,
            XMLCounters: {
                all: 0,
                added: 0
            },
            groups: [],
            fileLoading: false,
            jsonKatris: {},
            allMaterials: {},
            allRolo: [],
            allVertical: [],
            allPlisse: [],
            linkContent: 'ЗНАК КАЧЕСТВА<br/><img src="/img/itemListLogo.png" style="width: 80%; display: block; margin: 0 auto;" />',
            qualityFlagsArray: [],
            activeThumbID: 0,
            notifyList: [],
            activeVideoLink: '',
            boxAction: [],
            timeout: 5000,
            filterData: {
                colors: [],
                prices: [],
                blackouts: [],
                types: []
            },
            filtersAvailable: {
                colors: [],
                prices: [],
                blackouts: [],
                types: []
            },
            filterOpened: true,
            lastTopID: 30003576,
            zebraParents: [30005303, 30004424, 30005956, 30004423, 30005953, 30005938, 30005306, 30005259, 30006023, 30005316, 30005263, 30006026, 30005310, 30004425, 30005961, 30006029, 30005945, 30005941, 30005331, 30005967, 30005927, 30005232, 30005328, 30005267, 30005323, 30006032],
            colorsFilterOpened: false,
            squareMetersPrices: []
        }
    },
    computed: {
        filteredList() {
            let self = this;
            function compare(a, b) {
                if (a.name < b.name)
                    if (typeof InstallTrigger !== 'undefined') {
                        return -1;
                    } else {
                        return 1;
                    }
                if (a.name > b.name)
                    if (typeof InstallTrigger !== 'undefined') {
                        return 1;
                    } else {
                        return -1;
                    }

                return 0;
            }
            function action(a, b) {
                if (b.discount_pics_ids.indexOf(b.id) == -1)
                    return -1;
                if (b.discount_pics_ids.indexOf(b.id) !== -1)
                    return 1;
                return 0;
            }
            return this.activeList.filter(activeListItem => {
                return activeListItem.name.toLowerCase().includes(this.search.toLowerCase()) || activeListItem.id == this.search.toLowerCase()
                // return activeListItem.name.toLowerCase().includes(this.search.toLowerCase())
            }).sort(compare).sort(action).filter(activeListItem => {
                if (self.filterData.prices.length > 0 && ([9467, 8460, 30004973, 30004746].indexOf(self.lastTopID) != -1 || self.lastSelectedId == 8436)) {
                    if (self.filterData.prices.indexOf(activeListItem.priceGroup) != -1) {
                        return activeListItem;
                    }
                } else {
                    return activeListItem;
                }
            }).filter(activeListItem => {
                if (self.filterData.colors.length > 0 && ([9467, 8460, 30004973, 30004746].indexOf(self.lastTopID) != -1 || self.lastSelectedId == 8436)) {
                    if (self.filterData.colors.indexOf(activeListItem.colorGroup) != -1) {
                        return activeListItem;
                    }
                } else {
                    return activeListItem;
                }
            }).filter(activeListItem => {
                if (self.filterData.blackouts.length > 0 && ([9467, 8460, 30004973, 30004746].indexOf(self.lastTopID) != -1 || self.lastSelectedId == 8436)) {
                    if (self.filterData.blackouts.indexOf(activeListItem.blackoutGroup) != -1) {
                        return activeListItem;
                    }
                } else {
                    return activeListItem;
                }
            }).filter(activeListItem => {
                if (self.filterData.types.length == 2 || self.filterData.types.length == 0 || ([9467, 8460, 30004973, 30004746].indexOf(self.lastTopID) != -1 || self.lastSelectedId == 8436)) {
                    return activeListItem;
                } else {
                    if (self.filterData.types[0] == 1) {
                        if (self.zebraParents.indexOf(activeListItem.parent) == -1) {
                            return activeListItem;
                        }
                    } else if (self.filterData.types[0] == 2) {
                        if (self.zebraParents.indexOf(activeListItem.parent) != -1) {
                            return activeListItem;
                        }
                    }
                }
            })
        },
        manualSets() {
            let sorted = [];
            for (let key in this.sets) {
                if (this.sets[key].id == 0) sorted.push(this.sets[key]);
            }
            return sorted;
        }
    },
    created() {
        let self = this;

        let params = {
            url: 'https://sale.katris.ru/proxy/',
            session: this.$session.get('user')
        };

        ai_helper.init(params, function() {
            ai_helper.restoreComplects();
            self.restore();
        });

        if (ai_helper.complects.length > 0) this.saleFlag = true;

        this.count = this.$countGlobal;

        series([
            function(done) {
                ai_helper.makePost('katrisService', 'getNotifications', {'token': self.$session.get('jwt')}, null, function(response) {
                    if (response.status === 'OK') {
                        self.notifyList = response.data;
                        done()
                    }
                });
            },
            function(done) {
                ai_helper.makePost('katrisService', 'getQualityFlags', {'token': self.$session.get('jwt')}, null, function(response) {
                    if (response.status === 'OK') {
                        self.qualityFlagsArray = response.data;
                        done()
                    }
                });
            },
            function(done) {
                ai_helper.makePost('katrisService', 'getKatrisGoods', {}, null, function (respond) {
                    if (respond.status === 'OK') {
                        self.jsonKatris = respond.data;
                        done()
                    }
                });
            },
            // function(done) {
            //     ai_helper.makePost('katrisService', 'getBoxAction', {'token': self.$session.get('jwt')}, null, function (response) {
            //         if (response.status === 'OK') {
            //             for (let item in response.data) {
            //                 self.boxAction.push(parseInt(response.data[item].goodID))
            //             }
            //             done()
            //         }
            //     });
            // },
            function(done) {
                ai_helper.makePost('katrisService', 'getPriceSquareMeter', {'token': self.$session.get('jwt')}, null, function (response) {
                    if (response.status === 'OK') {
                        self.squareMetersPrices = response.data;
                        console.log('prices', self.squareMetersPrices)
                        done()
                    }
                });
            },
            function() {
                ai_helper.makePost('aiHelper', 'get_common_cat', {}, null, function (respond) {
                    if (respond.status === 'OK') {
                        for (let key in respond.data) {
                            respond.data[key].expanded = false;
                        }

                        let sortFunction = function (a, b) {
                            let aname = a.name.toLowerCase();
                            let bname = b.name.toLowerCase();
                            if (aname < bname) return -1;
                            if (aname > bname) return 1;
                        };

                        // console.log(respond.data)

                        let items1 = Object.keys(respond.data).map(function (key) {
                            return respond.data[key];
                        });
                        items1.sort(sortFunction);
                        for (let k1 in items1) {
                            items1[k1].items = Object.keys(items1[k1].items).map(function (key) {
                                return items1[k1].items[key];
                            });
                            items1[k1].items.sort(sortFunction);
                            for (let k2 in items1[k1].items) {
                                items1[k1].items[k2].items = Object.keys(items1[k1].items[k2].items).map(function (key) {
                                    return items1[k1].items[k2].items[key];
                                });
                                items1[k1].items[k2].items.sort(sortFunction);
                            }
                        }

                        let mats = [];

                        for (let group in items1) {
                            if (items1[group].id == 9467) {
                                for (let i in items1[group].items) {
                                    if (items1[group].items[i].id == 30004746) {
                                        mats = items1[group].items[i];
                                        items1[group].items.splice(i, 1);
                                        items1.push(mats);
                                    }
                                }
                            }
                        }

                        self.menu = items1;

                        let groups = [];

                        for (let group in self.menu) {
                            groups.push({'id': self.menu[group].id, 'parent': 0});

                            for (let group2 in self.menu[group].items) {
                                groups.push({
                                    'id': self.menu[group].items[group2].id,
                                    'parent': self.menu[group].id
                                });

                                for (let group3 in self.menu[group].items[group2].items) {
                                    groups.push({
                                        'id': self.menu[group].items[group2].items[group3].id,
                                        'parent': self.menu[group].items[group2].id
                                    });

                                    for (let group4 in self.menu[group].items[group2].items[group3].items) {
                                        groups.push({
                                            'id': self.menu[group].items[group2].items[group3].items[group4].id,
                                            'parent': self.menu[group].items[group2].items[group3].id
                                        });
                                    }
                                }

                            }
                        }

                        self.groups = groups;

                        self.toggleMenuItem(self.lastSelectedId);
                        self.updateActiveList(self.lastSelectedId);
                    }
                });
            }
        ]);
    },
    mounted() {
        // this.$modal.show('sale')
    },
    methods: {
        compare: function(a, b) {
            if (a.name < b.name)
                return -1;
            if (a.name > b.name)
                return 1;
            return 0;
        },
        restore: function() {
            let self = this;

            self.crm.user.uid = ai_helper.user.uid;

            for (let complect in ai_helper.complects) {
                let groups = [];
                if (ai_helper.complects[complect].calculated == true) {
                    // self.binFlag = true;
                    self.saleFlag = true;
                }

                for (let key in ai_helper.complects[complect].groups) {
                    let items = [];
                    for (let item in ai_helper.complects[complect].groups[key].items) {
                        // ai_helper.complects[complect].groups[key].items[item].clicked = false;

                        // if (ai_helper.complects[complect].id_good == '20000131' && ai_helper.complects[complect].groups[key].id == '8460' && [8696, 8693, 8694].indexOf(ai_helper.complects[complect].groups[key].items[item].id) == -1) {
                        // ai_helper.complects[complect].groups[key].items[item].allowEdit = true;
                        // } else {
                        //     ai_helper.complects[complect].groups[key].items[item].allowEdit = false;
                        // }

                        items.push(ai_helper.complects[complect].groups[key].items[item]);
                    }
                    ai_helper.complects[complect].groups[key].items = items;
                    groups.push(ai_helper.complects[complect].groups[key]);
                }

                let goods = [];
                for (let key in ai_helper.complects[complect].goods) {
                    ai_helper.complects[complect].goods[key].clicked = false;
                    if (ai_helper.complects[complect].id != 0 && ai_helper.complects[complect].goods[key].count == 0) {
                        ai_helper.complects[complect].goods[key].count = ai_helper.complects[complect].goods[key].package;
                    }
                    ai_helper.complects[complect].goods[key].setDomValues();
                    goods.push(ai_helper.complects[complect].goods[key]);
                }

                ai_helper.complects[complect].groups = groups;

                ai_helper.complects[complect].goods = goods;
                ai_helper.complects[complect].goodsVisible = goods;

                ai_helper.complects[complect].parm1 = ai_helper.complects[complect].hh_add;
                ai_helper.complects[complect].folder = ai_helper.complects[complect].hh;
                ai_helper.complects[complect].alt_folder = ai_helper.complects[complect].hh_add;

                ai_helper.complects[complect].triggerCalcCount = false;
                ai_helper.complects[complect].triggerCalcSquare = false;

                ai_helper.complects[complect].get_basket_sum();

                self.sets.push(ai_helper.complects[complect]);

                // for (let key in self.menu) {
                //     if (self.sets.find(set => set.id == self.menu[key].id) != undefined) {
                //         self.menu.splice(key, 1);
                //     }
                // }
            }

            // let common = false;
            for (let set in self.sets) {
                // if (self.sets[set].id == 0) common = true
                // if (self.sets[set].minimized === false && self.sets[set].calculated === true) {
                //     self.setExpanded = set;
                // }

                for (let group in self.sets[set].groups) {
                    self.sets[set].groups[group].getActualAmount(function () {});
                }
            }

            // if (this.prevRoute.path == '/' && document.referrer.indexOf('/orderFromCatalog') != -1 && self.sets[self.sets.length - 1].id == 0) {
            //     for (let set in self.sets) {
            //         if (self.sets[set]['id'] != 0) {
            //             self.sets[set].minimized = true;
            //         } else {
            //             self.sets[set].minimized = false;
            //             self.setExpanded = set;
            //         }
            //     }
            // }

            self.updateAll();
            setTimeout(function() {
                self.updateAll();
            }, 5000);
        },
        updateAll: function() {
            this.crm.user.sum = ai_helper.user.sum;
            this.crm.fullsum = ai_helper.fullsum;
            this.crm.salesum = ai_helper.salesum;
            this.crm.saletotalsum = ai_helper.saletotalsum;
            this.crm.fullsumPreview = ai_helper.fullsumPreview;
            this.crm.salesumPreview = ai_helper.salesumPreview;
            this.crm.saletotalsumPreview = ai_helper.saletotalsumPreview;

            let manual = false;

            for (let key in ai_helper.complects) {
                if (ai_helper.complects[key] != 'empty') {
                    if (ai_helper.complects[key].id == 0) {
                        this.$countGlobal.manual = Object.keys(ai_helper.complects[key].goods).length;
                        manual = true;
                        // console.log(ai_helper.complects[key].goods)
                    }
                }
            }

            if (!manual) this.$countGlobal.manual = 0;
            this.count = this.$countGlobal;

            this.updateItems();
        },
        toggleMenuItem: function(id) {
            if (this.expandedId != -1) {
                for (let key in this.menu[this.expandedId].items) {
                    this.menu[this.expandedId].items[key].expanded = false;
                }
            }

            for (let key in this.menu) {
                if (this.menu[key].id == id) {
                    // this.menu[key].expanded = true;
                    this.menu[key].expanded = !this.menu[key].expanded;
                    if (!this.menu[key].expanded) {
                        this.expandedId = -1;
                    } else {
                        this.expandedId = key;
                    }
                    this.header = this.menu[key].name;
                    if (this.lastSelectedId != id) {
                        this.updateActiveList(id);
                    }
                } else {
                    this.menu[key].expanded = false;
                }
            }

            this.lastSelectedId = id;
            this.lastTopID = id;

            console.log('topid', this.lastTopID)

            this.filterData = {
                colors: [],
                prices: [],
                blackouts: [],
                types: []
            }
        },
        selectMenuItemChild: function(id, parentId) {
            let self = this;
            self.filterData = {
                colors: [],
                prices: [],
                blackouts: [],
                types: []
            }

            let menuItem;
            this.lastSelectedId = id;
            console.log('lastSelectedId', this.lastSelectedId)
            if (parentId == 0) {
                menuItem = this.menu[this.expandedId].items.find(item => item.id == id);
                this.header = this.menu[this.expandedId].name + ' - ' + menuItem.name;
            } else {
                menuItem = this.menu[this.expandedId].items.find(parent => parent.id == parentId);
                this.header = this.menu[this.expandedId].name + ' - ' + menuItem.name;
                menuItem = menuItem.items.find(item => item.id == id);
                this.header += ' - ' + menuItem.name;
            }
            // menuItem.expanded = true;
            menuItem.expanded = !menuItem.expanded;

            this.updateActiveList(id);
        },
        updateActiveList: function(id) {
            let self = this;
            self.activeList = [];

            self.filtersAvailable = {
                colors: [],
                prices: [],
                blackouts: [],
                types: []
            }

            ai_helper.makePost('aiHelper', 'get_common_bubble', {id: id}, null, function(respond) {
                if (respond.status === 'OK') {
                    self.activeList = [];
                    let items = [];

                    // let discount = false;
                    //
                    // for (let obj in ai_helper.additionalDiscount) {
                    //     if (ai_helper.additionalDiscount[obj].groupID == id) {
                    //         discount = ai_helper.additionalDiscount[obj].discount;
                    //     }
                    // }
                    //
                    // // console.log('id', id);
                    //
                    // if (!discount) {
                    //     for (let obj in self.groups) {
                    //         if (self.groups[obj].id == id) {
                    //             if (self.groups[obj].parent != 0) {
                    //                 for (let obj2 in ai_helper.additionalDiscount) {
                    //                     if (ai_helper.additionalDiscount[obj2].groupID == self.groups[obj].parent) {
                    //                         discount = ai_helper.additionalDiscount[obj2].discount;
                    //                     }
                    //                 }
                    //
                    //                 if (!discount) {
                    //                     for (let obj2 in self.groups) {
                    //                         if (self.groups[obj2].id == self.groups[obj].parent) {
                    //                             if (self.groups[obj2].parent != 0) {
                    //                                 for (let obj3 in ai_helper.additionalDiscount) {
                    //                                     if (ai_helper.additionalDiscount[obj3].groupID == self.groups[obj2].parent) {
                    //                                         discount = ai_helper.additionalDiscount[obj3].discount;
                    //                                     }
                    //                                 }
                    //                             }
                    //                         }
                    //                     }
                    //                 }
                    //             }
                    //         }
                    //     }
                    // }

                    for (let key in respond.data.items) {
                        console.log(respond.data.items[key])

                        //test
                        // respond.data.items[key].name = "<span style='color:red'>123</span>";
                        // respond.data.items[key].name_trunc = "<span style='color:red'>123</span>";

                        self.filtersAvailable.blackouts.push(respond.data.items[key].blackoutGroup);
                        self.filtersAvailable.prices.push(respond.data.items[key].priceGroup);
                        self.filtersAvailable.colors.push(respond.data.items[key].colorGroup);

                        let discount = false;

                        let parent = self.jsonKatris.goods[respond.data.items[key].id].id_parent;

                        if (self.zebraParents.indexOf(parent) != -1) {
                            self.filtersAvailable.types.push(2);
                        } else {
                            self.filtersAvailable.types.push(1);
                        }

                        for (let obj in ai_helper.additionalDiscount) {
                            if (ai_helper.additionalDiscount[obj].groupID == parent) {
                                discount = ai_helper.additionalDiscount[obj].discount;
                            }
                        }

                        if (!discount) {
                            for (let obj in self.groups) {
                                if (self.groups[obj].id == parent) {
                                    if (self.groups[obj].parent != 0) {
                                        for (let obj2 in ai_helper.additionalDiscount) {
                                            if (ai_helper.additionalDiscount[obj2].groupID == self.groups[obj].parent) {
                                                discount = ai_helper.additionalDiscount[obj2].discount;
                                            }
                                        }

                                        if (!discount) {
                                            for (let obj2 in self.groups) {
                                                if (self.groups[obj2].id == self.groups[obj].parent) {
                                                    if (self.groups[obj2].parent != 0) {
                                                        for (let obj3 in ai_helper.additionalDiscount) {
                                                            if (ai_helper.additionalDiscount[obj3].groupID == self.groups[obj2].parent) {
                                                                discount = ai_helper.additionalDiscount[obj3].discount;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        let discount2 = false;

                        for (let obj in ai_helper.additionalDiscount) {
                            if (ai_helper.additionalDiscount[obj].goodID == respond.data.items[key].id) {
                                // console.log('check')
                                // console.log(ai_helper.additionalDiscount[obj].goodID, respond.data.items[key].id)
                                discount2 = ai_helper.additionalDiscount[obj].discount;
                            }
                        }

                        if (discount) respond.data.items[key].real_sale = discount;
                        if (discount2) respond.data.items[key].real_sale = discount2;
                        // discount2 = false;
                        if (discount || discount2) respond.data.items[key].additionalDiscount = true;
                        // console.log(discount2)

                        let item = new AI_helperItemClass(respond.data.items[key], ai_helper, false, 'groupAdd');
                        item.selected = false;
                        item.parent = parent;

                        // self.activeList.push(item);
                        items.push(item);
                    }

                    self.filtersAvailable.colors = [...new Set(self.filtersAvailable.colors)];
                    self.filtersAvailable.prices = [...new Set(self.filtersAvailable.prices)];
                    self.filtersAvailable.blackouts = [...new Set(self.filtersAvailable.blackouts)];
                    self.filtersAvailable.types = [...new Set(self.filtersAvailable.types)];

                    for (let key in items) {
                        items[key].privileges = [];
                        items[key].selected = false;
                        items[key].clicked = false;
                        items[key].clicked2 = false;
                        items[key].privilegesExpanded = false;
                        items[key].analogs = false;
                        items[key].analogsExpanded = false;
                        items[key].analogsArray = [];
                        items[key].count = items[key].package;
                        items[key].sum = items[key].count * items[key].priceRub;
                        items[key].sale_sum = items[key].count * items[key].priceRubSale;

                        items[key].notify = false;
                        items[key].notificationID = 0;

                        items[key].box = false;
                        items[key].count1 = items[key].count;
                        items[key].count2 = 800;

                        if (items[key].stockColor == '#BDF0BD') items[key].stockColor = '#fff';

                        self.activeList.push(items[key]);
                    }

                    let analogParentsArray = [8436, 8460, 9467, 30004973];

                    if (self.lastSelectedId == 8460) {
                        self.allVertical = self.activeList;
                    } else if (self.lastSelectedId == 9467) {
                        self.allRolo = self.activeList;
                    } else if (self.lastSelectedId == 30004973) {
                        self.allPlisse = self.activeList;
                    }

                    for (let key in self.activeList) {
                        self.activeList[key].qualityFlag = false;
                        self.activeList[key].qualityFlagText = '';
                        self.activeList[key].videoLink = '';
                    }

                    for (let key in self.activeList) {
                        for (let flag in self.qualityFlagsArray) {
                            if (self.qualityFlagsArray[flag].goodID == self.activeList[key].id && self.qualityFlagsArray[flag].active == 1) {
                                self.activeList[key].qualityFlag = true;
                                self.activeList[key].qualityFlagText = self.qualityFlagsArray[flag].text;
                                self.activeList[key].videoLink = self.qualityFlagsArray[flag].videoLink;
                            } else if (self.qualityFlagsArray[flag].goodID == self.activeList[key].id) {
                                self.activeList[key].qualityFlag = false;
                                self.activeList[key].qualityFlagText = '';
                                self.activeList[key].videoLink = '';
                            }
                        }

                        for (let notify in self.notifyList) {
                            if (self.notifyList[notify].goodID == self.activeList[key].id && self.notifyList[notify].active == 1 && self.notifyList[notify].type == 2) {
                                self.activeList[key].notify = true;
                                self.activeList[key].notificationID = self.notifyList[notify].id;
                            } else if (self.notifyList[notify].goodID == self.activeList[key].id) {
                                self.activeList[key].notify = false;
                            }
                        }

                        if (!(self.activeList[key].enableStock || self.activeList[key].enableStock2 || self.activeList[key].enableStock3) && !self.activeList[key].has_priv) {
                            let parentID = 0;

                            if (self.jsonKatris.folders[self.jsonKatris.goods[self.activeList[key].id].id_parent]) {
                                parentID = self.jsonKatris.folders[self.jsonKatris.goods[self.activeList[key].id].id_parent].id_parent;
                                if (self.jsonKatris.folders[parentID] && self.jsonKatris.folders[parentID].id_parent != 0) {
                                    parentID = self.jsonKatris.folders[parentID].id_parent;
                                }
                            } else {
                                parentID = self.jsonKatris.goods[self.jsonKatris.goods[self.activeList[key].id].id_parent].id_parent;
                                parentID = self.jsonKatris.folders[parentID].id_parent;
                                if (self.jsonKatris.folders[parentID] && self.jsonKatris.folders[parentID].id_parent != 0) {
                                    parentID = self.jsonKatris.folders[parentID].id_parent;
                                }
                            }

                            let analogsList;
                            if (self.jsonKatris.goods[self.activeList[key].id].id_parent == 8460 || parentID == 8460) {
                                analogsList = self.allVertical;
                            } else if (self.jsonKatris.goods[self.activeList[key].id].id_parent == 9467 || parentID == 9467) {
                                analogsList = self.allRolo;
                            } else if (self.jsonKatris.goods[self.activeList[key].id].id_parent == 30004973 || parentID == 30004973) {
                                analogsList = self.allPlisse;
                            } else {
                                analogsList = self.activeList;
                            }

                            if (analogParentsArray.indexOf(self.jsonKatris.goods[self.activeList[key].id].id_parent) != -1 || analogParentsArray.indexOf(parentID) != -1 || analogParentsArray.indexOf(self.activeList[key].id) != -1) {
                                for (let key2 in analogsList) {
                                    if (analogsList[key2].colorGroup == self.activeList[key].colorGroup && (analogsList[key2].enableStock || analogsList[key2].enableStock2 || analogsList[key2].enableStock3)) {
                                        if (self.jsonKatris.folders[self.jsonKatris.goods[self.activeList[key].id].id_parent].id_parent != 30004423) {
                                            if (self.jsonKatris.folders[self.jsonKatris.goods[analogsList[key2].id].id_parent].id_parent != 30004423) {
                                                self.activeList[key].analogsArray.push(analogsList[key2]);

                                                if (!self.activeList[key].analogs) self.activeList[key].analogs = true;
                                            }
                                        } else {
                                            if (self.jsonKatris.folders[self.jsonKatris.goods[analogsList[key2].id].id_parent].id_parent == 30004423) {
                                                self.activeList[key].analogsArray.push(analogsList[key2]);

                                                if (!self.activeList[key].analogs) self.activeList[key].analogs = true;
                                            }
                                        }
                                    }
                                }
                            }

                            if (self.activeList[key].analogs) self.activeList[key].analogsArray.sort(self.compare);
                        }
                    }

                    self.updateItems();
                }
            });
        },
        select: function(id, privilegeId, analog = null) {
            if (!analog) {
                for (let key in this.activeList) {
                    if (this.activeList[key].id == id) {
                        if (privilegeId == 0) {
                            this.addList.push(this.activeList[key]);
                            this.activeList[key].selected = true;
                        } else {
                            for (let key2 in this.activeList[key].privileges) {
                                if (this.activeList[key].privileges[key2].id == privilegeId) {
                                    this.addList.push(this.activeList[key].privileges[key2]);
                                    this.activeList[key].privileges[key2].selected = true;
                                }
                            }
                        }
                    }
                }
            } else {
                this.addList.push(analog);
                analog.selected = true;
            }
            this.addedButton = true;
            this.add();
        },
        remove: function(id, privilegeId, analog = null) {
            let self = this;
            let itemId = (privilegeId == 0) ? id : privilegeId;

            for (let set in ai_helper.complects) {
                if (ai_helper.complects[set].id == 0) {
                    for (let item in ai_helper.complects[set].goods) {
                        if (ai_helper.complects[set].goods[item].id == itemId) {
                            // delete ai_helper.complects[set].goods[item];

                            ai_helper.complects[set].deleteItem(ai_helper.complects[set].goods[item]);


                            if (Object.keys(ai_helper.complects[set].goods).length == 0) {
                                delete ai_helper.complects[set];
                            }
                        }
                    }
                }
            }

            if (!analog) {
                for (let key in this.activeList) {
                    if (this.activeList[key].id == id) {
                        if (privilegeId == 0) {
                            this.activeList[key].selected = false;
                        } else {
                            for (let key2 in this.activeList[key].privileges) {
                                if (this.activeList[key].privileges[key2].id == privilegeId) {
                                    this.activeList[key].privileges[key2].selected = false;
                                }
                            }
                        }
                    }
                }
            } else analog.selected = false;

            ai_helper.check_complect();

            this.$countGlobal.number = 0;
            this.$countGlobal.basket = 0;

            for (let key in ai_helper.complects) {
                if (ai_helper.complects[key] != 'empty') {
                    // console.log(ai_helper.complects[key].inBusket)
                    if (ai_helper.complects[key].id != 0) {
                        if (ai_helper.complects[key].inBusket)
                            this.$countGlobal.basket++;
                        else
                            this.$countGlobal.number++;
                    } else {
                        this.$countGlobal.manual = Object.keys(ai_helper.complects[key].goods).length;
                    }
                }
            }

            this.count = this.$countGlobal;

            // self.restore();

            // setTimeout(function() {
            self.updateAll();
            // }, 1500);

            // console.log(ai_helper.complects)
        },
        add: function() {
            let self = this;

            if (self.addList[0]) {
                let common = 0;
                for (let key in ai_helper.complects) {
                    if (ai_helper.complects[key].id == 0) {
                        common = 1;
                    }
                }

                if (common == 0) {
                    ai_helper.add_complect({
                        id: "0",
                        folder: "Добавлено из каталога",
                        name: "",
                        id_good: 0
                    });

                    this.saleFlag = true;

                    this.sets = [];

                    for (let key in ai_helper.complects) {
                        self.sets.push(ai_helper.complects[key]);
                    }
                }

                for (let key in ai_helper.complects) {
                    if (ai_helper.complects[key].id == 0) {
                        for (let newItem in self.addList) {
                            let exists = false;
                            for (let good in ai_helper.complects[key].goods) {
                                if (ai_helper.complects[key].goods[good].id == self.addList[newItem].id) exists = true;
                            }

                            if (!exists) {
                                ai_helper.complects[key].goods[self.addList[newItem].id] = new AI_helperItemClass(self.addList[newItem], ai_helper);

                                console.log(ai_helper.complects[key].goods[self.addList[newItem].id])

                                ai_helper.check_complect();

                                // let fullSum = ai_helper.complects[key].fullsum;
                                //
                                // console.log('itemId', itemId)
                                //
                                // ai_helper.makePost('katrisService', 'getGoodAIHelperInfo', {id: itemId}, null, function(respond) {
                                //     if (respond.status === 'OK') {
                                //
                                //         console.log('res', respond)
                                //
                                //         if (respond.data.group != null && respond.data.set) {
                                //             let calcSet;
                                //             let partData = respond.data;
                                //
                                //             let data = {id: 0, count: 0, square: 0};
                                //
                                //             ai_helper.makePost('aiHelper', 'init_info', data, null, function(respond) {
                                //                 let setObj = 0;
                                //
                                //                 for (let key in respond.data.complects) {
                                //                     if (respond.data.complects[key].id_good == partData.set.id_good && respond.data.complects[key].parm1 == partData.set.parm1) {
                                //                         setObj = respond.data.complects[key];
                                //                     }
                                //                 }
                                //                 if (setObj != 0) {
                                //                     calcSet = new AI_helperComplectClass(setObj, 0, ai_helper);
                                //
                                //                     calcSet.parts(calcSet.id, 100, 0, false, function() {
                                //                         let sum = calcSet.get_basket_sum();
                                //
                                //                         if (sum < ai_helper.complects[key].fullsum) sum = fullSum;
                                //
                                //                         calcSet.check_complect_exe({fullsum: 0, fullsumPreview: sum});
                                //
                                //                         let added = false;
                                //
                                //                         if (!calcSet.goods[itemId]) {
                                //                             for (let group in calcSet.groups) {
                                //                                 if (calcSet.groups[group].id_good_inet == partData.set.id_good_inet) {
                                //                                     let founded = false;
                                //                                     for (let item in calcSet.groups[group].items) {
                                //                                         if (calcSet.groups[group].items[item].id == itemId) {
                                //                                             founded = true;
                                //                                             added = true;
                                //
                                //                                             addedItem.standartSet = partData.set.id_good;
                                //                                             addedItem.standartSetParam1 = partData.set.parm1;
                                //                                             addedItem.standartGroup = partData.set.id_good_inet;
                                //
                                //                                             if (addedItem.priceRubSale > calcSet.groups[group].items[item].priceRubSale)
                                //                                                 addedItem.aiCalculatedPrice = calcSet.groups[group].items[item].priceRubSale;
                                //
                                //                                             ai_helper.check_complect();
                                //                                         }
                                //                                     }
                                //                                     if (!founded) {
                                //                                         let groups_request = [{
                                //                                             id: calcSet.groups[group].id,
                                //                                             id_good_inet: calcSet.groups[group].id_good_inet,
                                //                                             gids: calcSet.groups[group].gids
                                //                                         }];
                                //
                                //                                         calcSet.get_groups_bubbles(groups_request, function (data) {
                                //                                             calcSet.groups[group].items[itemId] = new AI_helperItemClass(data[calcSet.groups[group].id][itemId], ai_helper, false, 'groupAdd');
                                //
                                //                                             calcSet.groups[group].event();
                                //                                             calcSet.groups[group].getActualAmount();
                                //
                                //                                             let sum = calcSet.get_basket_sum();
                                //                                             if (sum < ai_helper.complects[key].fullsum) sum = fullSum;
                                //
                                //                                             console.log('fullSum', fullSum)
                                //                                             console.log('calcSet', calcSet)
                                //
                                //                                             calcSet.check_complect_exe({fullsum: 0, fullsumPreview: sum});
                                //
                                //                                             addedItem.standartSet = partData.set.id_good;
                                //                                             addedItem.standartSetParam1 = partData.set.parm1;
                                //                                             addedItem.standartGroup = partData.set.id_good_inet;
                                //
                                //                                             if (addedItem.priceRubSale > calcSet.groups[group].items[itemId].priceRubSale)
                                //                                                 addedItem.aiCalculatedPrice = calcSet.groups[group].items[itemId].priceRubSale;
                                //
                                //                                             added = true;
                                //
                                //                                             ai_helper.check_complect();
                                //                                         });
                                //
                                //                                     }
                                //                                 }
                                //                             }
                                //                         } else {
                                //                             console.log('good', calcSet.goods[itemId]);
                                //
                                //                             addedItem.standartSet = partData.set.id_good;
                                //                             addedItem.standartSetParam1 = partData.set.parm1;
                                //                             addedItem.standartGroup = partData.set.id_good_inet;
                                //
                                //                             if (addedItem.priceRubSale > calcSet.goods[itemId].priceRubSale)
                                //                                 addedItem.aiCalculatedPrice = calcSet.goods[itemId].priceRubSale;
                                //                         }
                                //
                                //                         console.log('added', added)
                                //                     });
                                //                 }
                                //             });
                                //         } else {
                                //             let material;
                                //             if (self.allMaterials[itemId] && ['karniz', 'roma', 'catalog', 'access'].indexOf(self.allMaterials[itemId]) == -1) {
                                //                 material = self.allMaterials[itemId];
                                //
                                //                 let partData = {};
                                //
                                //                 switch (material.ptype) {
                                //                     case 'rolo':
                                //                         partData = {
                                //                             set: {
                                //                                 id_good: "20000163",
                                //                                 id_good_inet: "222",
                                //                                 parm1: "D-25"
                                //                             }
                                //                         };
                                //                         break;
                                //                     case 'vblinds':
                                //                         partData = {
                                //                             set: {
                                //                                 id_good: "20000131",
                                //                                 id_good_inet: "11",
                                //                                 parm1: "классик"
                                //                             }
                                //                         };
                                //                         break;
                                //                     case 'ks25':
                                //                         partData = {
                                //                             set: {
                                //                                 id_good: "30003858",
                                //                                 id_good_inet: "69",
                                //                                 parm1: ""
                                //                             }
                                //                         };
                                //                         break;
                                //                     case 'karniz':
                                //                         break;
                                //                     case 'plisse':
                                //                         partData = {
                                //                             set: {
                                //                                 id_good: "30005223",
                                //                                 id_good_inet: "514",
                                //                                 parm1: ""
                                //                             }
                                //                         };
                                //                         break;
                                //                     case 'roma':
                                //                         break;
                                //                     case 'zebra':
                                //                         partData = {
                                //                             set: {
                                //                                 id_good: "20000163",
                                //                                 id_good_inet: "228",
                                //                                 parm1: "Zebra Slim"
                                //                             }
                                //                         };
                                //                         break;
                                //                     case 'catalog':
                                //                         break;
                                //                     case 'access':
                                //                         break;
                                //                 }
                                //
                                //                 console.log(partData)
                                //
                                //                 let calcSet;
                                //
                                //                 let data = {id: 0, count: 0, square: 0};
                                //
                                //                 ai_helper.makePost('aiHelper', 'init_info', data, null, function(respond) {
                                //                     let setObj = 0;
                                //
                                //                     for (let key in respond.data.complects) {
                                //                         if (respond.data.complects[key].id_good == partData.set.id_good && respond.data.complects[key].parm1 == partData.set.parm1) {
                                //                             setObj = respond.data.complects[key];
                                //                         }
                                //                     }
                                //
                                //                     console.log('setObj', setObj)
                                //
                                //                     if (setObj != 0) {
                                //                         calcSet = new AI_helperComplectClass(setObj, 0, ai_helper);
                                //
                                //                         calcSet.parts(calcSet.id, 100, 0, false, function() {
                                //                             let sum = calcSet.get_basket_sum();
                                //
                                //                             if (sum < ai_helper.complects[key].fullsum) sum = fullSum;
                                //
                                //                             calcSet.check_complect_exe({
                                //                                 fullsum: 0,
                                //                                 fullsumPreview: sum
                                //                             });
                                //
                                //                             console.log(calcSet)
                                //
                                //                             for (let group in calcSet.groups) {
                                //                                 console.log(calcSet.groups[group].id_good_inet, partData.set.id_good_inet)
                                //                                 if (calcSet.groups[group].id_good_inet == partData.set.id_good_inet) {
                                //                                     let founded = false;
                                //                                     for (let item in calcSet.groups[group].items) {
                                //                                         if (calcSet.groups[group].items[item].id == itemId) {
                                //                                             founded = true;
                                //
                                //                                             if (addedItem.priceRubSale > calcSet.groups[group].items[item].priceRubSale)
                                //                                                 addedItem.aiCalculatedPrice = calcSet.groups[group].items[item].priceRubSale;
                                //
                                //                                             ai_helper.check_complect();
                                //                                         }
                                //                                     }
                                //                                     if (!founded) {
                                //                                         let groups_request = [{
                                //                                             id: calcSet.groups[group].id,
                                //                                             id_good_inet: calcSet.groups[group].id_good_inet,
                                //                                             gids: calcSet.groups[group].gids
                                //                                         }];
                                //
                                //                                         calcSet.get_groups_bubbles(groups_request, function (data) {
                                //                                             calcSet.groups[group].items[itemId] = new AI_helperItemClass(data[calcSet.groups[group].id][itemId], ai_helper, false, 'groupAdd');
                                //
                                //                                             calcSet.groups[group].event();
                                //                                             calcSet.groups[group].getActualAmount();
                                //
                                //                                             let sum = calcSet.get_basket_sum();
                                //                                             if (sum < ai_helper.complects[key].fullsum) sum = fullSum;
                                //                                             calcSet.check_complect_exe({fullsum: 0, fullsumPreview: sum});
                                //
                                //                                             addedItem.standartSet = partData.set.id_good;
                                //                                             addedItem.standartSetParam1 = partData.set.parm1;
                                //                                             addedItem.standartGroup = partData.set.id_good_inet;
                                //
                                //                                             if (addedItem.priceRubSale > calcSet.groups[group].items[itemId].priceRubSale)
                                //                                                 addedItem.aiCalculatedPrice = calcSet.groups[group].items[itemId].priceRubSale;
                                //
                                //                                             ai_helper.check_complect();
                                //                                         });
                                //
                                //                                     }
                                //                                 }
                                //                             }
                                //                         });
                                //                     }
                                //                 });
                                //             }
                                //         }
                                //     }
                                // });
                            }
                        }
                        ai_helper.complects[key].minimized = true;
                    }
                }

                ai_helper.storeComplects();

                self.addList = [];

                ai_helper.check_complect();
                self.updateAll();
            }

            // self.$router.push({path: '/configurator'});
        },
        itemPlus: function(itemId, privilegeId, analog = null) {
            let self = this;
            if (!analog) {
                for (let item in this.activeList) {
                    if (privilegeId == 0) {
                        if (this.activeList[item].id == itemId) {
                            if (this.activeList[item].count + this.activeList[item].package <= this.activeList[item].gdsInStock) {
                                this.activeList[item].box = false;
                                this.activeList[item].count = this.activeList[item].count1;

                                this.activeList[item].count += this.activeList[item].package;
                                this.activeList[item].sum = this.activeList[item].count * this.activeList[item].priceRub;
                                this.activeList[item].sale_sum = this.activeList[item].count * this.activeList[item].priceRubSale;

                                this.activeList[item].count1 = this.activeList[item].count;

                                this.activeList[item].setDomValues();

                                if (this.activeList[item].selected) {
                                    for (let key in this.sets) {
                                        if (this.sets[key].id == 0) {
                                            for (let i in self.sets[key].goods) {
                                                if (self.sets[key].goods[i].id == itemId) {
                                                    self.sets[key].goods[i].count = self.activeList[item].count;
                                                    self.sets[key].goods[i].sum = self.activeList[item].sum;
                                                    self.sets[key].goods[i].sale_sum = self.activeList[item].sale_sum;

                                                    self.sets[key].goods[i].setDomValues();
                                                    self.sets[key].event();

                                                    self.sets[key].get_basket_sum();
                                                    ai_helper.storeComplects();
                                                }
                                            }
                                        }
                                    }
                                }
                            } else {
                                this.activeList[item].clicked = true;
                                setTimeout(function () {
                                    self.activeList[item].clicked = false;
                                }, 2500);
                            }
                        }
                    } else {
                        if (this.activeList[item].id == itemId) {
                            for (let privilege in this.activeList[item].privileges) {
                                if (this.activeList[item].privileges[privilege].id == privilegeId) {

                                    if (this.activeList[item].privileges[privilege].count + this.activeList[item].privileges[privilege].package <= this.activeList[item].privileges[privilege].gdsInStock) {
                                        this.activeList[item].privileges[privilege].count += this.activeList[item].privileges[privilege].package;
                                        this.activeList[item].privileges[privilege].sum = this.activeList[item].privileges[privilege].count * this.activeList[item].privileges[privilege].priceRub;
                                        this.activeList[item].privileges[privilege].sale_sum = this.activeList[item].privileges[privilege].count * this.activeList[item].privileges[privilege].priceRubSale;
                                    } else {
                                        this.activeList[item].privileges[privilege].clicked = true;
                                        setTimeout(function () {
                                            self.activeList[item].privileges[privilege].clicked = false;
                                        }, 2500);
                                    }
                                    // console.log(this.activeList[item].privileges[privilege].count, this.activeList[item].privileges[privilege].package, this.activeList[item].privileges[privilege].gdsInStock, this.activeList[item].privileges[privilege].clicked)
                                }
                            }
                        }
                    }
                }
            } else {
                if (analog.count + analog.package <= analog.gdsInStock) {
                    analog.count += analog.package;
                    analog.sum = analog.count * analog.priceRub;
                    analog.sale_sum = analog.count * analog.priceRubSale;
                } else {
                    analog.clicked = true;
                    setTimeout(function () {
                        analog.clicked = false;
                    }, 2500);
                }
            }
            self.updateAll();
        },
        itemMinus: function(itemId, privilegeId, analog = null) {
            let self = this;
            if (!analog) {
                for (let item in this.activeList) {
                    if (this.activeList[item].id == itemId) {
                        if (privilegeId == 0) {
                            if (this.activeList[item].count > 0 && (this.activeList[item].count - this.activeList[item].package) > 0) {
                                this.activeList[item].box = false;
                                this.activeList[item].count = this.activeList[item].count1;

                                this.activeList[item].count -= this.activeList[item].package;
                                this.activeList[item].sum = this.activeList[item].count * this.activeList[item].priceRub;
                                this.activeList[item].sale_sum = this.activeList[item].count * this.activeList[item].priceRubSale;

                                this.activeList[item].count1 = this.activeList[item].count;

                                this.activeList[item].setDomValues();

                                if (this.activeList[item].selected) {
                                    for (let key in this.sets) {
                                        if (this.sets[key].id == 0) {
                                            for (let i in self.sets[key].goods) {
                                                if (self.sets[key].goods[i].id == itemId) {
                                                    self.sets[key].goods[i].count = self.activeList[item].count;
                                                    self.sets[key].goods[i].sum = self.activeList[item].sum;
                                                    self.sets[key].goods[i].sale_sum = self.activeList[item].sale_sum;

                                                    self.sets[key].goods[i].setDomValues();
                                                    self.sets[key].event();

                                                    self.sets[key].get_basket_sum();
                                                    ai_helper.storeComplects();
                                                }
                                            }
                                        }
                                    }
                                }
                            } else {
                                this.activeList[item].clicked2 = true;
                                this.activeList[item].timeout = 5000;
                                setTimeout(function () {
                                    self.activeList[item].clicked2 = false;
                                }, this.activeList[item].timeout);
                            }
                        } else {
                            for (let privilege in this.activeList[item].privileges) {
                                if (this.activeList[item].privileges[privilege].id == privilegeId) {
                                    if (this.activeList[item].privileges[privilege].count > 0 && (this.activeList[item].privileges[privilege].count - this.activeList[item].privileges[privilege].package) > 0) {
                                        this.activeList[item].privileges[privilege].count -= this.activeList[item].privileges[privilege].package;
                                        this.activeList[item].privileges[privilege].sum = this.activeList[item].privileges[privilege].count * this.activeList[item].privileges[privilege].priceRub;
                                        this.activeList[item].privileges[privilege].sale_sum = this.activeList[item].privileges[privilege].count * this.activeList[item].privileges[privilege].priceRubSale;
                                    }
                                }
                            }
                        }
                    }
                }
            } else {
                if (analog.count > 0 && (analog.count - analog.package) > 0) {
                    analog.count -= analog.package;
                    analog.sum = analog.count * analog.priceRub;
                    analog.sale_sum = analog.count * analog.priceRubSale;
                }
            }
            self.updateAll();
        },
        itemPlusBox: function(itemId, privilegeId, analog = null) {
            let self = this;
            if (!analog) {
                for (let item in this.activeList) {
                    if (privilegeId == 0) {
                        let number = 800;

                        if (this.activeList[item].id == itemId) {
                            if (this.activeList[item].count + number <= this.activeList[item].gdsInStock) {
                                this.activeList[item].box = true;
                                this.activeList[item].count = this.activeList[item].count2;

                                this.activeList[item].count += number;
                                this.activeList[item].sum = this.activeList[item].count * this.activeList[item].priceRub;
                                this.activeList[item].sale_sum = this.activeList[item].count * this.activeList[item].priceRubSale;

                                this.activeList[item].count2 = this.activeList[item].count;

                                this.activeList[item].setDomValues();

                                if (this.activeList[item].selected) {
                                    for (let key in this.sets) {
                                        if (this.sets[key].id == 0) {
                                            for (let i in self.sets[key].goods) {
                                                if (self.sets[key].goods[i].id == itemId) {
                                                    self.sets[key].goods[i].count = self.activeList[item].count;
                                                    self.sets[key].goods[i].sum = self.activeList[item].sum;
                                                    self.sets[key].goods[i].sale_sum = self.activeList[item].sale_sum;

                                                    self.sets[key].goods[i].setDomValues();
                                                    self.sets[key].event();

                                                    self.sets[key].get_basket_sum();
                                                    ai_helper.storeComplects();
                                                }
                                            }
                                        }
                                    }
                                }
                            } else {
                                this.activeList[item].clicked = true;
                                setTimeout(function () {
                                    self.activeList[item].clicked = false;
                                }, 2500);
                            }
                        }
                    }
                }
            } else {
                if (analog.count + analog.package <= analog.gdsInStock) {
                    analog.count += analog.package;
                    analog.sum = analog.count * analog.priceRub;
                    analog.sale_sum = analog.count * analog.priceRubSale;
                } else {
                    analog.clicked = true;
                    setTimeout(function () {
                        analog.clicked = false;
                    }, 2500);
                }
            }
            self.updateAll();
        },
        itemMinusBox: function(itemId, privilegeId, analog = null) {
            let self = this;
            if (!analog) {
                for (let item in this.activeList) {
                    if (this.activeList[item].id == itemId) {
                        if (privilegeId == 0) {
                            let number = 800;

                            if (this.activeList[item].count > 0 && (this.activeList[item].count - number) > 0) {
                                this.activeList[item].box = true;
                                this.activeList[item].count = this.activeList[item].count2;

                                this.activeList[item].count -= number;
                                this.activeList[item].sum = this.activeList[item].count * this.activeList[item].priceRub;
                                this.activeList[item].sale_sum = this.activeList[item].count * this.activeList[item].priceRubSale;

                                this.activeList[item].count2 = this.activeList[item].count;
                                this.activeList[item].setDomValues();

                                if (this.activeList[item].selected) {
                                    for (let key in this.sets) {
                                        if (this.sets[key].id == 0) {
                                            for (let i in self.sets[key].goods) {
                                                if (self.sets[key].goods[i].id == itemId) {
                                                    self.sets[key].goods[i].count = self.activeList[item].count;
                                                    self.sets[key].goods[i].sum = self.activeList[item].sum;
                                                    self.sets[key].goods[i].sale_sum = self.activeList[item].sale_sum;

                                                    self.sets[key].goods[i].setDomValues();
                                                    self.sets[key].event();

                                                    self.sets[key].get_basket_sum();
                                                    ai_helper.storeComplects();
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            } else {
                if (analog.count > 0 && (analog.count - analog.package) > 0) {
                    analog.count -= analog.package;
                    analog.sum = analog.count * analog.priceRub;
                    analog.sale_sum = analog.count * analog.priceRubSale;
                }
            }
            self.updateAll();
        },
        expandPrivileges: function(id) {
            let self = this;
            for (let key in self.activeList) {
                if (self.activeList[key].id == id) {
                    if (self.activeList[key].privileges.length == 0) {
                        // console.log(id)
                        ai_helper.makePost('aiHelper', 'get_privilege_bubble', {
                            id: self.activeList[key].id,
                            color: self.activeList[key].stockColor
                        }, null, function (respond) {
                            let privileges = [];
                            if (respond.status === 'OK') {
                                // console.log(respond.data)
                                for (let item in respond.data) {
                                    if (respond.data[item].enableStock) {
                                        respond.data[item].count = respond.data[item].package;
                                        respond.data[item].sum = respond.data[item].priceRub * respond.data[item].count;
                                        respond.data[item].sale_sum = respond.data[item].priceRubSale * respond.data[item].count;
                                        let privilege = new AI_helperItemClass(respond.data[item], ai_helper, false, 'groupAdd');
                                        privilege.selected = false;
                                        privilege.clicked = false;
                                        privileges.push(privilege);
                                    }
                                }
                                self.activeList[key].privileges = privileges;
                                self.activeList[key].privilegesExpanded = !self.activeList[key].privilegesExpanded;
                            } else {
                                console.error('Error loading privileges');
                            }
                        });
                    } else {
                        self.activeList[key].privilegesExpanded = !self.activeList[key].privilegesExpanded;
                    }
                }
            }
        },
        expandAnalogs: function(id) {
            let self = this;
            for (let key in self.activeList) {
                if (self.activeList[key].id == id) {
                    self.activeList[key].analogsExpanded = !self.activeList[key].analogsExpanded;
                }
            }
        },
        updateCount: function(itemId, privilegeId, fix, analog = null) {
            let self = this;
            if (!analog) {
                for (let item in this.activeList) {
                    if (this.activeList[item].id == itemId) {
                        if (this.boxAction.indexOf(itemId) != -1) {
                            this.activeList[item].box = false;
                            this.activeList[item].count = this.activeList[item].count1;
                        }

                        if (privilegeId == 0) {
                            if (this.activeList[item].count > this.activeList[item].gdsInStock && fix) {
                                this.activeList[item].count = this.activeList[item].gdsInStock;

                                this.activeList[item].clicked = true;
                                setTimeout(function () {
                                    self.activeList[item].clicked = false;
                                }, 2500);
                            } else if (this.activeList[item].count < this.activeList[item].package && fix) {
                                this.activeList[item].count = this.activeList[item].package;
                                this.activeList[item].clicked2 = true;
                                this.activeList[item].timeout = 5000;
                                setTimeout(function () {
                                    self.activeList[item].clicked2 = false;
                                }, self.activeList[item].timeout);
                            }

                            if (fix) {
                                this.activeList[item].count = Math.floor(this.activeList[item].count / this.activeList[item].package) * this.activeList[item].package;
                            }

                            this.activeList[item].sum = this.activeList[item].count * this.activeList[item].priceRub;
                            this.activeList[item].sale_sum = this.activeList[item].count * this.activeList[item].priceRubSale;

                            if (this.activeList[item].selected) {
                                for (let key in this.sets) {
                                    if (this.sets[key].id == 0) {
                                        for (let i in self.sets[key].goods) {
                                            if (self.sets[key].goods[i].id == itemId) {
                                                self.sets[key].goods[i].count = self.activeList[item].count;
                                                self.sets[key].goods[i].sum = self.activeList[item].sum;
                                                self.sets[key].goods[i].sale_sum = self.activeList[item].sale_sum;

                                                self.sets[key].goods[i].setDomValues();
                                                self.sets[key].event();

                                                self.sets[key].get_basket_sum();
                                                ai_helper.storeComplects();
                                            }
                                        }
                                    }
                                }
                            }
                        } else {
                            for (let privilege in this.activeList[item].privileges) {
                                if (this.activeList[item].privileges[privilege].id == privilegeId) {
                                    if (this.activeList[item].privileges[privilege].count > this.activeList[item].privileges[privilege].gdsInStock && fix) {
                                        this.activeList[item].privileges[privilege].count = this.activeList[item].privileges[privilege].gdsInStock;

                                        this.activeList[item].privileges[privilege].clicked = true;
                                        setTimeout(function () {
                                            self.activeList[item].privileges[privilege].clicked = false;
                                        }, 2500);
                                    } else if (this.activeList[item].privileges[privilege].count < this.activeList[item].privileges[privilege].package && fix) {
                                        this.activeList[item].privileges[privilege].count = this.activeList[item].privileges[privilege].package;
                                    }

                                    if (fix) {
                                        this.activeList[item].privileges[privilege].count = Math.floor(this.activeList[item].privileges[privilege].count / this.activeList[item].privileges[privilege].package) * this.activeList[item].privileges[privilege].package;
                                    }

                                    this.activeList[item].privileges[privilege].sum = this.activeList[item].privileges[privilege].count * this.activeList[item].privileges[privilege].priceRub;
                                    this.activeList[item].privileges[privilege].sale_sum = this.activeList[item].privileges[privilege].count * this.activeList[item].privileges[privilege].priceRubSale;
                                }
                            }
                        }

                        if (this.boxAction.indexOf(itemId) != -1) this.activeList[item].count1 = this.activeList[item].count;
                    }
                }
            } else {
                if (analog.count > analog.gdsInStock && fix) {
                    analog.count = analog.gdsInStock;

                    analog.clicked = true;
                    setTimeout(function () {
                        analog.clicked = false;
                    }, 2500);
                } else if (analog.count < analog.package && fix) {
                    analog.count = analog.package;
                }

                if (fix) {
                    analog.count = Math.floor(analog.count / analog.package) * analog.package;
                }

                analog.sum = analog.count * analog.priceRub;
                analog.sale_sum = analog.count * analog.priceRubSale;
            }


            self.updateAll();
        },
        updateCountBox: function(itemId, privilegeId, fix, analog = null) {
            let self = this;
            let number = 800;
            if (!analog) {
                for (let item in this.activeList) {
                    if (this.activeList[item].id == itemId) {
                        this.activeList[item].box = true;
                        this.activeList[item].count = this.activeList[item].count2;
                        if (privilegeId == 0) {
                            if (this.activeList[item].count > this.activeList[item].gdsInStock && fix) {
                                this.activeList[item].count = this.activeList[item].gdsInStock;

                                this.activeList[item].clicked = true;
                                setTimeout(function () {
                                    self.activeList[item].clicked = false;
                                }, 2500);
                            } else if (this.activeList[item].count < number && fix) {
                                this.activeList[item].count = number;
                            }

                            if (fix) {
                                this.activeList[item].count = Math.floor(this.activeList[item].count / number) * number;
                            }

                            this.activeList[item].sum = this.activeList[item].count * this.activeList[item].priceRub;
                            this.activeList[item].sale_sum = this.activeList[item].count * this.activeList[item].priceRubSale;

                            if (this.activeList[item].selected) {
                                for (let key in this.sets) {
                                    if (this.sets[key].id == 0) {
                                        for (let i in self.sets[key].goods) {
                                            if (self.sets[key].goods[i].id == itemId) {
                                                self.sets[key].goods[i].count = self.activeList[item].count;
                                                self.sets[key].goods[i].sum = self.activeList[item].sum;
                                                self.sets[key].goods[i].sale_sum = self.activeList[item].sale_sum;

                                                self.sets[key].goods[i].setDomValues();
                                                self.sets[key].event();

                                                self.sets[key].get_basket_sum();
                                                ai_helper.storeComplects();
                                            }
                                        }
                                    }
                                }
                            }

                            this.activeList[item].count2 = this.activeList[item].count;
                        }
                    }
                }
            } else {
                if (analog.count > analog.gdsInStock && fix) {
                    analog.count = analog.gdsInStock;

                    analog.clicked = true;
                    setTimeout(function () {
                        analog.clicked = false;
                    }, 2500);
                } else if (analog.count < analog.package && fix) {
                    analog.count = analog.package;
                }

                if (fix) {
                    analog.count = Math.floor(analog.count / analog.package) * analog.package;
                }

                analog.sum = analog.count * analog.priceRub;
                analog.sale_sum = analog.count * analog.priceRubSale;
            }


            self.updateAll();
        },
        openSale: function() {
            this.saleVisible = !this.saleVisible;
        },
        openPartnerProgram: function() {
            ai_helper.makePost('aiHelper', 'sales', {}, null,function(respond) {
                if (respond.status === 'OK') {
                    document.getElementById('saleRules').innerHTML = respond.data;

                    document.querySelector('#saleRules table').classList.add("table");
                }
            });

            this.$modal.show('partner-program')
        },
        closePartnerProgram: function() {
            this.$modal.hide('partner-program')
        },
        attachFile() {
            let file = document.querySelector('#inputGroupFile');
            file = file.files[0];
            this.fileName = file.name;
            this.file = file;
        },
        loadXMLToOrder: function() {
            let self = this;

            if (!self.loadingActive) {
                self.loadingActive = true;

                self.loadingMessage = 'Загрузка...';

                if (this.file && this.fileName != '') {
                    let reader = new FileReader();
                    reader.readAsText(self.file);
                    reader.onload = function () {
                        // console.log(reader.result)
                        // let fileBase64 = String(reader.result);

                        let options = {
                            attributeNamePrefix: "@_",
                            attrNodeName: "attr", //default is 'false'
                            textNodeName: "#text",
                            // ignoreAttributes : true,
                            ignoreAttributes: false,
                            ignoreNameSpace: false,
                            allowBooleanAttributes: false,
                            parseNodeValue: true,
                            parseAttributeValue: false,
                            trimValues: true,
                            cdataTagName: "__cdata", //default is 'false'
                            cdataPositionChar: "\\c",
                            parseTrueNumberOnly: false,
                            arrayMode: false, //"strict"
                            // attrValueProcessor: (val, attrName) => he.decode(val, {isAttributeValue: true}),//default is a=>a
                            // tagValueProcessor : (val, tagName) => he.decode(val), //default is a=>a
                            stopNodes: ["parse-me-as-string"]
                        };

                        let jsonObj = parser.parse(reader.result, options);

                        // console.log(jsonObj)

                        let menuLength = self.menu.length;

                        let obj = 0;

                        // let getJSON = function(url, callback) {
                        //     let xhr = new XMLHttpRequest();
                        //     xhr.open('GET', url, true);
                        //     xhr.responseType = 'json';
                        //     xhr.onload = function() {
                        //         // let status = xhr.status;
                        //         callback(xhr.response);
                        //     };
                        //     xhr.send();
                        // };

                        let xmlBaseID = 0;

                        function getList() {
                            // getJSON('https://api.foroom.ru/uploads/download/json/get_katris_goods.json', function(result) {
                            let json = {data: self.jsonKatris};

                            ai_helper.makePost('aiHelper', 'get_common_bubble', {id: self.menu[obj].id}, null, function (respond) {
                                if (respond.status === 'OK') {
                                    self.menu[obj].goods = respond.data.items;
                                }

                                obj++;
                                if (obj < menuLength) {
                                    getList()
                                } else {
                                    if (!jsonObj.ЗаказПоставщику.Товары.Номенклатура) {
                                        for (let obj2 in jsonObj.ЗаказПоставщику.Товары) {
                                            self.XMLCounters.all++;
                                            let xmlID = null;
                                            let xmlName = null;

                                            if (jsonObj.ЗаказПоставщику.Товары[obj2].Номенклатура && jsonObj.ЗаказПоставщику.Товары[obj2].Номенклатура.attr) {
                                                if (jsonObj.ЗаказПоставщику.Товары[obj2].Номенклатура.attr['@_Наименование']) {
                                                    xmlName = jsonObj.ЗаказПоставщику.Товары[obj2].Номенклатура.attr['@_Наименование'];
                                                }

                                                if (jsonObj.ЗаказПоставщику.Товары[obj2].Номенклатура.attr['@_Идентификатор']) {
                                                    xmlID = jsonObj.ЗаказПоставщику.Товары[obj2].Номенклатура.attr['@_Идентификатор'];
                                                }

                                                if (xmlID !== null || xmlName !== null) {
                                                    let foundedItem;

                                                    for (let group in self.menu) {
                                                        for (let item in self.menu[group].goods) {
                                                            if (xmlID && xmlID == self.menu[group].goods[item].id) {
                                                                foundedItem = self.menu[group].goods[item];
                                                                break;
                                                            } else if (xmlName && xmlName == self.menu[group].goods[item].name) {
                                                                foundedItem = self.menu[group].goods[item];
                                                                break;
                                                            }
                                                        }
                                                    }

                                                    if (foundedItem != undefined) {
                                                        if (foundedItem.enableStock) {
                                                            self.XMLCounters.added++;
                                                            let log = 'Добавлено в корзину. ';
                                                            if (xmlID) log += 'ID: ' + xmlID + '. ';
                                                            if (xmlName) log += xmlName + '. ';
                                                            log += '\n';

                                                            if (jsonObj.ЗаказПоставщику.Товары[obj2].Количество) {
                                                                if (jsonObj.ЗаказПоставщику.Товары[obj2].Количество < foundedItem.gdsInStock) {
                                                                    foundedItem.count = jsonObj.ЗаказПоставщику.Товары[obj2].Количество;
                                                                } else {
                                                                    foundedItem.count = foundedItem.gdsInStock;
                                                                    // log += ' Кол-во на складе: ' + foundedItem.gdsInStock;
                                                                    log += 'Изменено кол–во, в соответствии с наличием на складе' + '\n';
                                                                }

                                                                if (jsonObj.ЗаказПоставщику.Товары[obj2].Количество < foundedItem.package && foundedItem.gdsInStock > foundedItem.package) {
                                                                    foundedItem.count = foundedItem.package;
                                                                    // log += ' Минимальный заказ: ' + foundedItem.package;
                                                                    log += 'Исправлена ошибка: изменено кол–во, в соответствии с кратностью упаковки' + '\n';
                                                                }

                                                                if (jsonObj.ЗаказПоставщику.Товары[obj2].Количество % foundedItem.package != 0 && foundedItem.gdsInStock > foundedItem.package) {
                                                                    foundedItem.count = Math.floor(foundedItem.count / foundedItem.package) * foundedItem.package;
                                                                    // log += ' Кол-во должно быть кратно ' + foundedItem.package;
                                                                    log += 'Исправлена ошибка: изменено кол–во, в соответствии с кратностью упаковки' + '\n';
                                                                }
                                                            }

                                                            let discount = false;

                                                            let parent = json.data.goods[foundedItem.id].id_parent;

                                                            for (let obj in ai_helper.additionalDiscount) {
                                                                if (ai_helper.additionalDiscount[obj].groupID == parent) {
                                                                    discount = ai_helper.additionalDiscount[obj].discount;
                                                                    console.log('ds1', discount)
                                                                }
                                                            }

                                                            if (!discount) {
                                                                for (let obj in self.groups) {
                                                                    if (self.groups[obj].id == parent) {
                                                                        if (self.groups[obj].parent != 0) {
                                                                            for (let obj2 in ai_helper.additionalDiscount) {
                                                                                if (ai_helper.additionalDiscount[obj2].groupID == self.groups[obj].parent) {
                                                                                    discount = ai_helper.additionalDiscount[obj2].discount;
                                                                                    console.log('ds2', discount)
                                                                                }
                                                                            }

                                                                            if (!discount) {
                                                                                for (let obj2 in self.groups) {
                                                                                    if (self.groups[obj2].id == self.groups[obj].parent) {
                                                                                        if (self.groups[obj2].parent != 0) {
                                                                                            for (let obj3 in ai_helper.additionalDiscount) {
                                                                                                if (ai_helper.additionalDiscount[obj3].groupID == self.groups[obj2].parent) {
                                                                                                    discount = ai_helper.additionalDiscount[obj3].discount;
                                                                                                    console.log('ds3', discount)
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }

                                                            let discount2 = false;

                                                            for (let obj in ai_helper.additionalDiscount) {
                                                                if (ai_helper.additionalDiscount[obj].goodID == foundedItem.id) {
                                                                    discount2 = ai_helper.additionalDiscount[obj].discount;
                                                                    console.log('ds4', discount2)
                                                                }
                                                            }

                                                            if (discount) foundedItem.real_sale = discount;
                                                            if (discount2) foundedItem.real_sale = discount2;
                                                            if (discount || discount2) foundedItem.additionalDiscount = true;

                                                            console.log('rs', foundedItem.real_sale)

                                                            foundedItem.xmlId = xmlBaseID;

                                                            log += '\n';

                                                            self.loadingLog += log;

                                                            self.addList.push(foundedItem);
                                                            self.add();
                                                        } else {
                                                            let log = 'Не добавлено в корзину. Нет в наличии. ';
                                                            if (xmlID) log += 'ID: ' + xmlID + '. ';
                                                            if (xmlName) log += xmlName + '. ';
                                                            log += '\n\n';

                                                            self.loadingLog += log;
                                                        }
                                                    } else {
                                                        let log = 'Не добавлено в корзину. Позиция не найдена. ';
                                                        if (xmlID) log += 'ID: ' + xmlID + '. ';
                                                        if (xmlName) log += xmlName + '. ';
                                                        log += '\n\n';

                                                        self.loadingLog += log;
                                                    }
                                                } else {
                                                    self.loadingLog += 'Не добавлено в корзину. У позиции не указано ID и наименование!\n';
                                                }
                                            }
                                        }
                                    } else {
                                        self.XMLCounters.all = 1;
                                        let xmlID = null;
                                        let xmlName = null;

                                        if (jsonObj.ЗаказПоставщику.Товары.Номенклатура && jsonObj.ЗаказПоставщику.Товары.Номенклатура.attr) {
                                            if (jsonObj.ЗаказПоставщику.Товары.Номенклатура.attr['@_Наименование']) {
                                                xmlName = jsonObj.ЗаказПоставщику.Товары.Номенклатура.attr['@_Наименование'];
                                            }

                                            if (jsonObj.ЗаказПоставщику.Товары.Номенклатура.attr['@_Идентификатор']) {
                                                xmlID = jsonObj.ЗаказПоставщику.Товары.Номенклатура.attr['@_Идентификатор'];
                                            }

                                            if (xmlID !== null || xmlName !== null) {
                                                let foundedItem;

                                                for (let group in self.menu) {
                                                    for (let item in self.menu[group].goods) {
                                                        if (xmlID && xmlID == self.menu[group].goods[item].id) {
                                                            foundedItem = self.menu[group].goods[item];
                                                            break;
                                                        } else if (xmlName && xmlName == self.menu[group].goods[item].name) {
                                                            foundedItem = self.menu[group].goods[item];
                                                            break;
                                                        }
                                                    }
                                                }

                                                if (foundedItem != undefined) {
                                                    if (foundedItem.enableStock) {
                                                        self.XMLCounters.added++;
                                                        let log = 'Добавлено в корзину. ';
                                                        if (xmlID) log += 'ID: ' + xmlID + '. ';
                                                        if (xmlName) log += xmlName + '. ';
                                                        log += '\n';

                                                        if (jsonObj.ЗаказПоставщику.Товары.Количество) {
                                                            if (jsonObj.ЗаказПоставщику.Товары.Количество < foundedItem.gdsInStock) {
                                                                foundedItem.count = jsonObj.ЗаказПоставщику.Товары.Количество;
                                                            } else {
                                                                foundedItem.count = foundedItem.gdsInStock;
                                                                // log += ' Кол-во на складе: ' + foundedItem.gdsInStock;
                                                                log += 'Изменено кол–во, в соответствии с наличием на складе' + '\n';
                                                            }

                                                            if (jsonObj.ЗаказПоставщику.Товары.Количество < foundedItem.package && foundedItem.gdsInStock > foundedItem.package) {
                                                                foundedItem.count = foundedItem.package;
                                                                // log += ' Минимальный заказ: ' + foundedItem.package;
                                                                log += 'Исправлена ошибка: изменено кол–во, в соответствии с кратностью упаковки' + '\n';
                                                            }

                                                            if (jsonObj.ЗаказПоставщику.Товары.Количество % foundedItem.package != 0 && foundedItem.gdsInStock > foundedItem.package) {
                                                                foundedItem.count = Math.floor(foundedItem.count / foundedItem.package) * foundedItem.package;
                                                                // log += ' Кол-во должно быть кратно ' + foundedItem.package;
                                                                log += 'Исправлена ошибка: изменено кол–во, в соответствии с кратностью упаковки' + '\n';
                                                            }
                                                        }

                                                        log += '\n';

                                                        self.loadingLog += log;

                                                        let discount = false;

                                                        let parent = json.data.goods[foundedItem.id].id_parent;

                                                        for (let obj in ai_helper.additionalDiscount) {
                                                            if (ai_helper.additionalDiscount[obj].groupID == parent) {
                                                                discount = ai_helper.additionalDiscount[obj].discount;
                                                                console.log('ds5', discount)
                                                            }
                                                        }

                                                        if (!discount) {
                                                            for (let obj in self.groups) {
                                                                if (self.groups[obj].id == parent) {
                                                                    if (self.groups[obj].parent != 0) {
                                                                        for (let obj2 in ai_helper.additionalDiscount) {
                                                                            if (ai_helper.additionalDiscount[obj2].groupID == self.groups[obj].parent) {
                                                                                discount = ai_helper.additionalDiscount[obj2].discount;
                                                                                console.log('ds6', discount)
                                                                            }
                                                                        }

                                                                        if (!discount) {
                                                                            for (let obj2 in self.groups) {
                                                                                if (self.groups[obj2].id == self.groups[obj].parent) {
                                                                                    if (self.groups[obj2].parent != 0) {
                                                                                        for (let obj3 in ai_helper.additionalDiscount) {
                                                                                            if (ai_helper.additionalDiscount[obj3].groupID == self.groups[obj2].parent) {
                                                                                                discount = ai_helper.additionalDiscount[obj3].discount;
                                                                                                console.log('ds7', discount)
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }

                                                        let discount2 = false;

                                                        for (let obj in ai_helper.additionalDiscount) {
                                                            if (ai_helper.additionalDiscount[obj].goodID == foundedItem.id) {
                                                                discount2 = ai_helper.additionalDiscount[obj].discount;
                                                                console.log('ds8', discount)
                                                            }
                                                        }

                                                        if (discount) foundedItem.real_sale = discount;
                                                        if (discount2) foundedItem.real_sale = discount2;
                                                        if (discount || discount2) foundedItem.additionalDiscount = true;
                                                        console.log('rs2', foundedItem.real_sale)

                                                        foundedItem.xmlId = xmlBaseID;
                                                        console.log(foundedItem.xmlId, xmlBaseID)

                                                        self.addList.push(foundedItem);
                                                        self.add();
                                                    } else {
                                                        let log = 'Не добавлено в корзину. Нет в наличии. ';
                                                        if (xmlID) log += 'ID: ' + xmlID + '. ';
                                                        if (xmlName) log += xmlName + '. ';
                                                        log += '\n\n';

                                                        self.loadingLog += log;
                                                    }
                                                } else {
                                                    let log = 'Не добавлено в корзину. Позиция не найдена. ';
                                                    if (xmlID) log += 'ID: ' + xmlID + '. ';
                                                    if (xmlName) log += xmlName + '. ';
                                                    log += '\n\n';

                                                    self.loadingLog += log;
                                                }
                                            } else {
                                                self.loadingLog += 'Не добавлено в корзину. У позиции не указано ID и наименование!\n';
                                            }
                                        }
                                    }

                                    // ai_helper.makePost('katrisService', 'writeXmlStatistic', {
                                    //     contragentID: session.contragentId,
                                    //     userID: session.loginId
                                    // }, null, function (respond) {
                                    //     console.log(respond)
                                    // });

                                    self.loadingMessage = 'Загружено';
                                    self.loadingStatus = true;
                                    self.XMLAdded = true;
                                    setTimeout(function () {
                                        self.XMLAdded = false;
                                    }, 5000);
                                }

                            });
                        }

                        let session = self.$session.get('user');

                        ai_helper.makePost('katrisService', 'writeXmlStatistic', {
                            contragentID: session.contragentId,
                            userID: session.loginId
                        }, null, function (respond) {
                            xmlBaseID = respond.data.ID;

                            getList();
                        });
                    }
                } else {
                    // console.log(this.file, this.fileName)
                    self.loadingMessage = 'Прикрепите файл!';
                }
            }
        },
        resetXML: function() {
            let self = this;

            let file = document.querySelector('#inputGroupFile');
            file.value = '';

            self.file = null;
            self.fileName = 'Выбор файла';
            self.loadingMessage = '';
            self.loadingLog ='';
            self.loadingStatus = false;
            self.loadingActive = false;
            self.XMLCounters.all = 0;
            self.XMLCounters.added = 0;
            self.XMLAdded = false;
        },
        unloadXML: function() {
            let self = this;
            self.fileLoading = true;
            let obj = 0;

            let menuLength = self.menu.length;

            function getList() {
                ai_helper.makePost('aiHelper', 'get_common_bubble', {id: self.menu[obj].id}, null, function (respond) {
                    if (respond.status === 'OK') {
                        self.menu[obj].goods = respond.data.items;
                    }

                    obj++;
                    if (obj < menuLength) {
                        getList()
                    } else {
                        let root = builder.create('Группы');

                        root.att('Дата', new Date());

                        for (let group in self.menu) {
                            let newGroup = root.ele('ГруппаТоваров');
                            newGroup.att('Наименование', self.menu[group].name);

                            for (let good in self.menu[group].goods) {
                                let newGood = newGroup.ele('Товар');
                                // console.log(self.menu[group].goods[good])
                                newGood.att('Идентификатор', self.menu[group].goods[good].id);
                                newGood.att('Наименование', self.menu[group].goods[good].name);
                                newGood.att('МинимальныйЗаказ', self.menu[group].goods[good].package);
                                newGood.att('ЕдиницаИзмерения', self.menu[group].goods[good].measure);

                                let availability;

                                if (self.menu[group].goods[good].gdsInStock == 0 || self.menu[group].goods[good].gdsInStock < self.menu[group].goods[good].package) {
                                    availability = 'Нет';
                                } else if (self.menu[group].goods[good].gdsInStock > 0 && self.menu[group].goods[good].stockColor != "#FDFDB0") {
                                    availability = 'Есть';
                                } else {
                                    availability = 'НаОстатке'
                                }

                                newGood.att('Наличие', availability);
                            }
                        }

                        let xml = root.end({pretty: true});

                        let filename = "katrisCatalog.xml";
                        let pseudoelement = document.createElement("a");
                        let blob = new Blob([xml], { type: "text/plain" });

                        pseudoelement.setAttribute("href", window.URL.createObjectURL(blob));
                        pseudoelement.setAttribute("download", filename);

                        pseudoelement.dataset.downloadurl = ["text/plain", pseudoelement.download, pseudoelement.href].join(":");
                        pseudoelement.draggable = true;
                        pseudoelement.classList.add("dragout");

                        pseudoelement.click();
                        self.fileLoading = false;
                    }
                });
            }
            getList();
        },
        updateItems: function() {
            let self = this;

            let set;

            for (let key in this.sets) {
                if (this.sets[key].id == 0) set = this.sets[key];
            }

            if (set) {
                for (let item in this.activeList) {
                    if (!this.activeList[item].additionalDiscount) {
                        this.activeList[item].setSale(set.sale, set.wholeSum);
                    }

                    for (let item2 in self.activeList[item].analogsArray) {
                        if (!self.activeList[item].analogsArray[item2].additionalDiscount) {
                            self.activeList[item].analogsArray[item2].setSale(set.sale, set.wholeSum);
                        }
                    }
                }
            }
        },
        setActiveThumb: function(item) {
            let self = this;

            if (self.activeThumbID != item.id) {
                self.activeThumbID = item.id
            } else {
                self.activeThumbID = 0;
            }
        },
        closeFlag: function() {
            this.activeThumbID = 0;
        },
        notifyMe: function(item) {
            let self = this;
            ai_helper.makePost('katrisService', 'createNotification', {'token': this.$session.get('jwt'), 'goodID': item.id, 'type': 2}, null, function(respond) {
                if (respond.status === 'OK') {
                    item.notify = true;
                    item.notificationID = respond.data.ID;

                    self.$notificationsGlobal.waitListLength += 1;
                    if (self.$notificationsGlobal.emptyNotices) self.$notificationsGlobal.emptyNotices = false;
                }
            });
        },
        disableNotifications: function(item) {
            let self = this;
            ai_helper.makePost('katrisService', 'disableNotification', {'token': this.$session.get('jwt'), 'notificationID': item.notificationID}, null, function(respond) {
                if (respond.status === 'OK') {
                    item.notify = false;

                    self.$notificationsGlobal.waitListLength -= 1;
                    if (self.$notificationsGlobal.waitListLength == 0) self.$notificationsGlobal.emptyNotices = true;
                }
            });
        },
        openVideo: function(link) {
            this.activeVideoLink = link.replace("https://www.youtube.com/watch?v=", "https://www.youtube.com/embed/");
            this.$modal.show('video')
        },
        changeInput: function(item, type) {
            if (type == 1) {
                item.box = false;
                item.count = item.count1;
            } else {
                item.box = true;
                item.count = item.count2;
            }
            item.setDomValues();
        },
        toggleFilterData: function(type, name) {
            if (this.filterData[type].indexOf(name) == -1) {
                this.filterData[type].push(name)
                if (type == 'types' && name == 2) {
                    let pushBlackout = false;
                    if (this.filterData.blackouts.indexOf(5) != -1) {
                        pushBlackout = true
                    }
                    this.filterData.blackouts = [];
                    if (pushBlackout) {
                        this.filterData.blackouts.push(5)
                    }
                }
            } else {
                this.filterData[type].splice(this.filterData[type].indexOf(name), 1)
            }

            this.saveFilterData()
        },
        saveFilterData: function() {
            let self = this;
            if (self.search != '' || self.filterData.blackouts.length > 0 || self.filterData.types.length > 0 || self.filterData.colors.length > 0 || self.filterData.prices.length > 0) {
                ai_helper.makePost('katrisService', 'saveFilterData', {'token': this.$session.get('jwt'), 'filterData': JSON.stringify(self.filterData), 'searchField': self.search, 'group': self.lastSelectedId}, null, function(respond) {
                    console.log(respond.data)
                });
            }
        }
    }
}
</script>

<style scoped>
span.arrow {
    position: absolute;
    margin-left: 4px;
}

.backButton span {
    border-radius: 50%;
    height: 24px;
    width: 24px;
    display: inline-block;
    font-weight: bold;
    margin-left: 5px;
    font-size: 12px;
    text-align: center;
    line-height: 2;
}

.backButton.btn-primary span, .backButton.btn-outline-primary:hover span {
    background: #fff !important;
    color: #007bff !important;
}
.backButton.btn-outline-primary span {
    background: #007bff;
    color: #fff;
}

.custom-file-input:lang(en) ~ .custom-file-label::after {
    content: "Загрузить файл";
    background-color: #ffffff;
    border: 2px solid grey;
    border-radius: 0.25rem;
    width: 200px;
    text-align: center;
}

.buyMoreContainer {
    /*background-color: #27a0f9;*/
    background-color: #007bff;
    padding: 0 10px;
    padding-bottom: 10px;
    border-radius: 10px;
    /*margin-top: 20px;*/
}

.buyMoreContainer h3 {
    color: #fff;
    font-weight: 400 !important;
    margin-bottom: 0;
    padding: 10px;
}

.buyMore {
    /*background-color: #f0f8ffa3 !important;*/
    background-color: #fff !important;
    /*border-bottom: 1px solid #dee2e6;*/
    border-radius: 10px;
}

.buyMore tr:first-of-type td {
    border-top: none;
}

.btn-outline-primary {
    background: white;
}
.btn-outline-primary:hover {
    background: #007bff;
}

.thumb {
    position: absolute;
    right: -5px;
    top: 0px;
    font-size: 24px;
    cursor: pointer;
    color: #006ce0;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    resize: vertical;
}

.nameSpan {
    width: 95%;
    display: inline-block;
}

.popover {
    background: transparent !important;
    border: none !important;
}

.tooltip.popover .popover-inner {
    background: #007bff !important;
    color: #fff !important;
    padding: 5px 10px 4px !important;
    -webkit-box-shadow: 1px 1px 3px #00000094 !important;
    box-shadow: 1px 1px 3px #00000094 !important;
    border-radius: 16px !important;
}

.tooltip.popover .popover-arrow {
    background-color: #007bff !important;
}

.boxAction .input-group {
    width: 95%;
    /*display: inline-block;*/
    min-width: 0;
}

.boxAction .btn {
    padding: 0 0.15rem
}

.boxAction .input-group-prepend {
    /*display: inline-block;*/
}

.boxAction input {
    /*display: inline-block;*/
}

.boxAction .form-control {
    padding: 0.25rem 0;
    font-size: 12px;
}

.boxAction .form-control:focus {
    box-shadow: none;
}

.countField {
    display: inline-block;
    position: relative;
    width: 50%;
}

.boxAction .quantity-right-plus {
    border-bottom-left-radius: unset !important;
    border-top-left-radius: unset !important;
}

.boxAction .countField > span {
    text-align: center;
    display: block;
    font-size: 12px;
    font-weight: bold;
}

.boxAction .boxSale {
    background-color: red;
    color: white;
    display: inline-block;
    font-size: 10px;
    font-weight: bold;
    border-radius: 50%;
    padding: 5px 2px;
    position: absolute;
    z-index: 100;
    right: -10px;
    top: 15px;
}

.boxAction .notSelected > span {
    color: grey;
}

.boxAction .notSelected button, .boxAction .notSelected input {
    background-color: #b3b3b3;
}

.boxAction .notSelected .boxSale {
    background-color: #868686;
}

.boxAction > span {
    display: block;
    width: 100%;
    font-size: 12px;
    font-weight: bold;
    text-align: center;
    padding: 5px 0;
}

.filterButton {
    display: inline-block;
    color: #000;
    font-size: 15px;
    padding: 5px 0;
}

.filter-checkboxes .fieldset-checkbox > div {
    position: relative;
    display: inline-block;
    height: 20px;
    margin-right: 10px;
    margin-bottom: 7px;
}
.filter-checkboxes .fieldset-checkbox > div input {
    margin: 0;
}
.fieldset-checkbox__square input {
    position: absolute;
    z-index: -1;
    width: 20px !important;
    height: 20px !important;
    opacity: 0;
}
.fieldset-checkbox__square input + label {
    position: relative;
    padding: 2px 0 0 16px;
    cursor: pointer;
}
.filter-checkboxes .fieldset-checkbox > div input.red + label:before {
    background: #f50000;
}
.filter-checkboxes .fieldset-checkbox > div input.orange + label:before {
    background: #f99200;
}
.filter-checkboxes .fieldset-checkbox > div input.yellow + label:before {
    background: #ff0;
}
.filter-checkboxes .fieldset-checkbox > div input.green + label:before {
    background: #1a6f00;
}
.filter-checkboxes .fieldset-checkbox > div input.blue + label:before {
    background: #00f;
}
.filter-checkboxes .fieldset-checkbox > div input.purple + label:before {
    background: #6a2275;
}
.filter-checkboxes .fieldset-checkbox > div input.black + label:before {
    background: #000;
}
.filter-checkboxes .fieldset-checkbox > div input.white + label:before {
    background: #fff;
}
.filter-checkboxes .fieldset-checkbox > div input.beige + label:before {
    background: #f2f2d2;
}
.filter-checkboxes .fieldset-checkbox > div input.gray + label:before {
    background: #6c6c6c;
}
.filter-checkboxes .fieldset-checkbox > div input.brown + label:before {
    background: #623500;
}
.filter-checkboxes .fieldset-checkbox > div input.light_gray + label:before {
    background: #fff;
}
.filter-checkboxes .fieldset-checkbox > div input + label:before {
    border: 1px solid #aaa;
}
.fieldset-checkbox__square input + label:before {
    position: absolute;
    top: 4px;
    left: 0;
    width: 13px;
    height: 13px;
    content: '';
    -webkit-border-radius: 2px;
    border-radius: 2px;
}
.fieldset-checkbox__square input + label:after {
    position: absolute;
    top: 1px;
    left: -3px;
    width: 19px;
    height: 19px;
    content: '';
    -webkit-transition: .2s;
    transition: .2s;
    opacity: 0;
    border: 2px solid #007bff;
    -webkit-border-radius: 2px;
    border-radius: 4px;
}
.filter-checkboxes .filter-title {
    margin: 0px;
    font-weight: bold;
}
.fieldset-checkbox__square input:checked + label:after {
    opacity: 1;
}

.filter {
    border: 1px solid #dceafd;
    margin: 10px 0;
    border-radius: 15px;
    background-color: #eff6ff;
    padding-top: 5px;
}

.filter .button {
    border: 1px solid #ced4da;
    color: #495057;
    height: 30px;
    overflow: hidden;
    background-color: white;
    padding: 7px 9px;
}
.filter .button::after {
    display: inline-block;
    width: 0;
    height: 0;
    margin-left: 0.255em;
    vertical-align: 0.255em;
    content: "";
    border-top: 0.5em solid;
    border-right: 0.2em solid transparent;
    border-bottom: 0;
    border-left: 0.2em solid transparent;
    position: absolute;
    right: 25px;
    top: 30px;
    color: #495057;
}
.colorsFilter {
    position: absolute;
    background-color: white;
    z-index: 200;
    border: 1px solid #ced4da;
    box-shadow: 2px 3px 6px 0px #b9b9b9;
    padding: 5px 15px;
}
.colorsFilter .fieldset-checkbox > div {
    display: block !important;
}
.overlay {
    z-index: 9;
    display: block;
    height: 100vh;
    left: 0;
    position: fixed;
    top: 0;
    width: 100vw;
}

.animateNew {
    display: block;
    animation: new .5s linear infinite;
}

@keyframes new
{
    0%
    {
        transform:scaleX(1);
    }
    50%
    {
        transform:scaleX(.95);
    }
    100%
    {
        transform:scaleX(1);
    }
}
</style>
